export const ftdMonsters = [
  {
    name: "Adult Amethyst Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 161,
    size: ["H"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 19,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 229,
      formula: "17d12 + 119",
    },
    speed: {
      walk: 40,
      fly: {
        number: 80,
        condition: "(hover)",
      },
      swim: 40,
      canHover: true,
    },
    str: 25,
    dex: 14,
    con: 25,
    int: 20,
    wis: 17,
    cha: 21,
    save: {
      dex: "+7",
      con: "+12",
      wis: "+8",
      cha: "+10",
    },
    skill: {
      arcana: "+15",
      perception: "+13",
      persuasion: "+10",
      stealth: "+7",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 23,
    resist: ["force", "psychic"],
    conditionImmune: ["frightened", "prone"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: {
      cr: "16",
      lair: "17",
    },
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 18}):",
        ],
        daily: {
          "1e": [
            "{@spell blink}",
            "{@spell control water}",
            "{@spell dispel magic}",
            "{@spell protection from evil and good}",
            "{@spell sending}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon can breathe both air and water."],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 10 ft., one target. {@h}18 ({@damage 2d10 + 7}) piercing damage plus 9 ({@damage 2d8}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 10 ft., one target. {@h}11 ({@damage 1d8 + 7}) slashing damage.",
        ],
      },
      {
        name: "Singularity Breath {@recharge 5}",
        entries: [
          "The dragon creates a shining bead of gravitational force in its mouth, then releases the energy in a 90-foot cone. Each creature in that area must make a {@dc 20} Strength saving throw. On a failed save, the creature takes 45 ({@damage 10d8}) force damage, and its speed becomes 0 until the start of the dragon's next turn. On a successful save, the creature takes half as much damage, and its speed isn't reduced.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The dragon magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The dragon makes one claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The dragon uses Psychic Step or Spellcasting."],
      },
      {
        name: "Explosive Crystal (Costs 3 Actions)",
        entries: [
          "The dragon spits an amethyst that that explodes at a point it can see within 60 feet of it. Each creature within a 20-foot-radius sphere centered on that point must succeed on a {@dc 20} Dexterity saving throw or take 13 ({@damage 3d8}) force damage and be knocked {@condition prone}.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Amethyst Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 13} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "adult",
    traitTags: ["Amphibious", "Legendary Resistances"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["O", "P", "S"],
    damageTagsSpell: ["B"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["prone"],
    conditionInflictLegendary: ["charmed"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Adult Crystal Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 171,
    size: ["H"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["C", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 172,
      formula: "15d12 + 75",
    },
    speed: {
      walk: 40,
      burrow: 40,
      climb: 40,
      fly: 80,
    },
    str: 21,
    dex: 12,
    con: 21,
    int: 18,
    wis: 15,
    cha: 19,
    save: {
      dex: "+5",
      con: "+9",
      wis: "+6",
      cha: "+8",
    },
    skill: {
      perception: "+10",
      stealth: "+9",
      survival: "+6",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 20,
    resist: ["cold", "radiant"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: {
      cr: "12",
      lair: "13",
    },
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 16}):",
        ],
        will: ["{@spell dancing lights}", "{@spell guidance}"],
        daily: {
          "1e": [
            "{@spell command}",
            "{@spell divination}",
            "{@spell hypnotic pattern}",
            "{@spell lesser restoration}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 10 ft., one target. {@h}16 ({@damage 2d10 + 5}) piercing damage plus 4 ({@damage 1d8}) radiant damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}9 ({@damage 1d8 + 5}) slashing damage.",
        ],
      },
      {
        name: "Scintillating Breath {@recharge 5}",
        entries: [
          "The dragon exhales a burst of brilliant radiance in a 60-foot cone. Each creature in that area must make a {@dc 17} Constitution saving throw, taking 40 ({@damage 9d8}) radiant damage on a failed save, or half as much damage on a successful one. The dragon then gains 15 temporary hit points by absorbing a portion of the radiant energy.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The dragon magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The dragon makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The dragon uses Psychic Step or Spellcasting."],
      },
      {
        name: "Starlight Strike (Costs 3 Actions)",
        entries: [
          "The dragon releases a searing beam of starlight at a creature that it can see within 60 feet of it. The target must succeed on a {@dc 17} Dexterity saving throw or take 31 ({@damage 9d6}) radiant damage.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Crystal Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 12} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "adult",
    traitTags: ["Legendary Resistances"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["P", "R", "S"],
    damageTagsLegendary: ["R"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflictSpell: ["charmed", "incapacitated", "prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Adult Deep Dragon",
    source: "FTD",
    page: 174,
    size: ["H"],
    type: "dragon",
    alignment: ["N", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 147,
      formula: "14d12 + 56",
    },
    speed: {
      walk: 40,
      burrow: 30,
      fly: 80,
      swim: 40,
    },
    str: 20,
    dex: 14,
    con: 18,
    int: 16,
    wis: 16,
    cha: 18,
    save: {
      dex: "+6",
      con: "+8",
      wis: "+7",
      cha: "+8",
    },
    skill: {
      perception: "+7",
      persuasion: "+12",
      stealth: "+10",
    },
    senses: ["blindsight 60 ft.", "darkvision 150 ft."],
    passive: 17,
    resist: ["poison", "psychic"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic", "Undercommon"],
    cr: {
      cr: "11",
      lair: "12",
    },
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 10 ft., one target. {@h}16 ({@damage 2d10 + 5}) piercing damage plus 5 ({@damage 1d10}) poison damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d6 + 5}) slashing damage.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 15 ft., one target. {@h}9 ({@damage 1d8 + 5}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 17} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses its action to end it.",
        ],
      },
      {
        name: "Nightmare Breath {@recharge 5}",
        entries: [
          "The dragon exhales a cloud of spores in a 60-foot cone. Each creature in that area must make a {@dc 16} Wisdom saving throw. On a failed save, the creature takes 33 ({@damage 6d10}) psychic damage, and it is {@condition frightened} of the dragon for 1 minute. On a successful save, the creature takes half as much damage with no additional effects. A {@condition frightened} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
    ],
    legendary: [
      {
        name: "Commanding Spores",
        entries: [
          "The dragon releases spores around a creature within 30 feet of it that it can see. The target must succeed on a {@dc 16} Wisdom saving throw or use its reaction to make a melee weapon attack against a random creature within reach. If no creatures are within reach, or the target can't take a reaction, it takes 5 ({@damage 1d10}) psychic damage.",
        ],
      },
      {
        name: "Tail",
        entries: ["The dragon makes one Tail attack."],
      },
      {
        name: "Spore Salvo (Costs 2 Actions)",
        entries: [
          "The dragon releases poisonous spores around a creature within 30 feet of it that it can see. The target must succeed on a {@dc 16} Constitution saving throw or take 17 ({@damage 5d6}) poison damage and become {@condition poisoned} for 1 minute. The {@condition poisoned} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Deep Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 12} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "deep",
    dragonAge: "adult",
    traitTags: ["Legendary Resistances"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "U"],
    damageTags: ["B", "I", "P", "S", "Y"],
    damageTagsLegendary: ["I"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["frightened", "poisoned", "prone"],
    conditionInflictLegendary: ["poisoned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Adult Emerald Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 196,
    size: ["H"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["L", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 18,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 207,
      formula: "18d12 + 90",
    },
    speed: {
      walk: 40,
      burrow: 30,
      fly: 80,
    },
    str: 23,
    dex: 12,
    con: 21,
    int: 18,
    wis: 16,
    cha: 18,
    save: {
      dex: "+6",
      con: "+10",
      wis: "+8",
      cha: "+9",
    },
    skill: {
      arcana: "+9",
      deception: "+9",
      perception: "+13",
      stealth: "+6",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 23,
    resist: ["fire", "psychic"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: {
      cr: "14",
      lair: "15",
    },
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 17}):",
        ],
        will: [
          "{@spell mage hand} (the hand is invisible)",
          "{@spell minor illusion}",
        ],
        daily: {
          "1e": [
            "{@spell detect thoughts}",
            "{@spell dispel magic}",
            "{@spell invisibility}",
            "{@spell major image}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Shift Perception (1/Day)",
        entries: [
          "The dragon can cast {@spell hallucinatory terrain}, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 17}).",
        ],
      },
      {
        name: "Tunneler",
        entries: [
          "The dragon can burrow through solid rock at half its burrowing speed and can leave a 15-foot-diameter tunnel in its wake.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 11} to hit, reach 10 ft., one target. {@h}17 ({@damage 2d10 + 6}) piercing damage plus 7 ({@damage 2d6}) psychic damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 11} to hit, reach 5 ft., one target. {@h}10 ({@damage 1d8 + 6}) slashing damage.",
        ],
      },
      {
        name: "Disorienting Breath {@recharge 5}",
        entries: [
          "The dragon exhales a wave of psychic dissonance in a 60-foot cone. Each creature in that area must make a {@dc 18} Intelligence saving throw. On a failed save, the creature takes 42 ({@damage 12d6}) psychic damage, and until the end of its next turn, when the creature makes an attack roll or an ability check, it must roll a {@dice d6} and reduce the total by the number rolled. On a successful save, the creature takes half as much damage with no additional effects.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The dragon magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The dragon makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The dragon uses Psychic Step or Spellcasting."],
      },
      {
        name: "Emerald Embers (Costs 3 Actions)",
        entries: [
          "The dragon creates a dancing mote of green flame around a creature it can see within 60 feet of it. The target must succeed on a {@dc 17} Dexterity saving throw or take 31 ({@damage 9d6}) fire damage.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Emerald Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 17} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "adult",
    traitTags: ["Legendary Resistances", "Tunneler"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["F", "P", "S", "Y"],
    damageTagsLegendary: ["Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflictSpell: ["invisible"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Adult Moonstone Dragon",
    source: "FTD",
    page: 212,
    size: ["H"],
    type: "dragon",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 19,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 195,
      formula: "17d12 + 85",
    },
    speed: {
      walk: 40,
      fly: 80,
    },
    str: 20,
    dex: 18,
    con: 20,
    int: 22,
    wis: 20,
    cha: 23,
    save: {
      int: "+11",
      wis: "+10",
      cha: "+11",
    },
    skill: {
      perception: "+10",
      persuasion: "+11",
      stealth: "+9",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 20,
    conditionImmune: ["charmed"],
    languages: ["Common", "Draconic", "Elvish", "Gnomish", "Sylvan"],
    cr: {
      cr: "15",
      lair: "16",
    },
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 19}):",
        ],
        will: ["{@spell faerie fire}"],
        daily: {
          "1e": [
            "{@spell calm emotions}",
            "{@spell invisibility}",
            "{@spell revivify}",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 10 ft., one target. {@h}16 ({@damage 2d10 + 5}) piercing damage plus 7 ({@damage 2d6}) radiant damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 5 ft., one target. {@h}12 ({@damage 2d6 + 5}) slashing damage.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 15 ft., one target. {@h}9 ({@damage 1d8 + 5}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 18} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The dragon uses one of the following breath weapons:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                type: "item",
                name: "Dream Breath",
                entries: [
                  "The dragon exhales mist in a 90-foot cone. Each creature in that area must succeed on a {@dc 18} Constitution saving throw or fall {@condition unconscious} for 10 minutes. This effect ends for a creature if the creature takes damage or someone uses an action to wake it.",
                ],
              },
              {
                type: "item",
                name: "Moonlight Breath",
                entries: [
                  "The dragon exhales a beam of moonlight in a 90-foot line that is 10 feet wide. Each creature in that area must make a {@dc 18} Dexterity saving throw, taking 49 ({@damage 9d10}) radiant damage on a failed save, or half as much damage on a successful one.",
                ],
              },
            ],
          },
        ],
      },
    ],
    legendary: [
      {
        name: "Tail",
        entries: ["The dragon makes one Tail attack."],
      },
      {
        name: "Cast a Spell (Costs 2 Actions)",
        entries: ["The dragon uses Spellcasting."],
      },
    ],
    legendaryGroup: {
      name: "Moonstone Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 14} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "adult",
    traitTags: ["Legendary Resistances"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR", "E", "G", "S"],
    damageTags: ["B", "P", "R", "S"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["prone", "unconscious"],
    conditionInflictLegendary: ["incapacitated", "stunned"],
    conditionInflictSpell: ["invisible"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Adult Sapphire Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 215,
    size: ["H"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["L", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 18,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 225,
      formula: "18d12 + 108",
    },
    speed: {
      walk: 40,
      burrow: 30,
      climb: 40,
      fly: 80,
    },
    str: 23,
    dex: 14,
    con: 22,
    int: 18,
    wis: 17,
    cha: 18,
    save: {
      dex: "+7",
      con: "+11",
      wis: "+8",
      cha: "+9",
    },
    skill: {
      history: "+9",
      perception: "+13",
      persuasion: "+14",
      stealth: "+7",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 23,
    resist: ["lightning", "thunder"],
    conditionImmune: ["frightened"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: {
      cr: "15",
      lair: "16",
    },
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 17}):",
        ],
        daily: {
          "1e": [
            "{@spell dissonant whispers}",
            "{@spell hold monster}",
            "{@spell meld into stone}",
            "{@spell telekinesis}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Spider Climb",
        entries: [
          "The dragon can climb difficult surfaces, including upside down on ceilings, without needing to make an ability check.",
        ],
      },
      {
        name: "Tunneler",
        entries: [
          "The dragon can burrow through solid rock at half its burrowing speed and can leave a 10-foot-diameter tunnel in its wake.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 11} to hit, reach 10 ft., one target. {@h}17 ({@damage 2d10 + 6}) piercing damage plus 5 ({@damage 1d10}) thunder damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 11} to hit, reach 5 ft., one target. {@h}10 ({@damage 1d8 + 6}) slashing damage.",
        ],
      },
      {
        name: "Debilitating Breath {@recharge 5}",
        entries: [
          "The dragon exhales a pulse of high-pitched, nearly inaudible sound in a 60-foot cone. Each creature in that area must make a {@dc 19} Constitution saving throw. On a failed save, the creature takes 44 ({@damage 8d10}) thunder damage and is {@condition incapacitated} until the end of its next turn. On a successful save, the creature takes half as much damage and isn't {@condition incapacitated}.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The dragon magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The dragon makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The dragon uses Psychic Step or Spellcasting."],
      },
      {
        name: "Telekinetic Fling (Costs 3 Actions)",
        entries: [
          "The dragon chooses one Small or smaller object that isn't being worn or carried that it can see within 60 feet of it, and it magically hurls the object at a creature it can see within 60 feet of the object. The target must succeed on a {@dc 17} Dexterity saving throw or take 31 ({@damage 9d6}) bludgeoning damage.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Sapphire Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 12} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "adult",
    traitTags: ["Legendary Resistances", "Spider Climb", "Tunneler"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["B", "P", "S", "T"],
    damageTagsLegendary: ["T"],
    damageTagsSpell: ["B", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["incapacitated"],
    conditionInflictLegendary: ["charmed", "stunned"],
    conditionInflictSpell: ["paralyzed", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Adult Topaz Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 221,
    size: ["H"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["C", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 18,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 210,
      formula: "20d12 + 80",
    },
    speed: {
      walk: 40,
      fly: 80,
      swim: 40,
    },
    str: 19,
    dex: 12,
    con: 19,
    int: 18,
    wis: 17,
    cha: 18,
    save: {
      dex: "+6",
      con: "+9",
      wis: "+8",
      cha: "+9",
    },
    skill: {
      intimidation: "+14",
      perception: "+13",
      stealth: "+6",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 23,
    resist: ["cold", "necrotic"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: {
      cr: "13",
      lair: "14",
    },
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 17}):",
        ],
        daily: {
          "1e": [
            "{@spell bane}",
            "{@spell control water}",
            "{@spell create or destroy water}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon can breathe both air and water."],
      },
      {
        name: "Fabricate (1/Day)",
        entries: [
          "The dragon can cast {@spell fabricate}, requiring no spell components and using Intelligence as the spellcasting ability.",
        ],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 10 ft., one target. {@h}15 ({@damage 2d10 + 4}) piercing damage plus 3 ({@damage 1d6}) necrotic damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d8 + 4}) slashing damage.",
        ],
      },
      {
        name: "Desiccating Breath {@recharge 5}",
        entries: [
          "The dragon exhales yellowish necrotic energy in a 60-foot cone. Each creature in that area must make a {@dc 17} Constitution saving throw. On a failed save, the creature takes 35 ({@damage 10d6}) necrotic damage and is weakened until the end of its next turn. A weakened creature has disadvantage on Strength-based ability checks and Strength saving throws, and the creature's weapon attacks that rely on Strength deal half damage. On a successful save, the creature takes half as much damage and isn't weakened.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The dragon magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The dragon makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The dragon uses Psychic Step or Spellcasting."],
      },
      {
        name: "Essential Reduction (Costs 3 Actions)",
        entries: [
          "The dragon targets a creature or an object not being worn or carried that it can see within 60 feet of it. The target must succeed on a {@dc 17} Constitution saving throw or take 28 ({@damage 8d6}) necrotic damage. If this damage reduces the target to 0 hit points, it crumbles to dust.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Topaz Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 12} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "adult",
    traitTags: ["Amphibious", "Legendary Resistances"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["N", "P", "S"],
    damageTagsLegendary: ["N"],
    damageTagsSpell: ["B"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Amethyst Dragon Wyrmling",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 162,
    size: ["M"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 75,
      formula: "10d8 + 30",
    },
    speed: {
      walk: 30,
      fly: {
        number: 60,
        condition: "(hover)",
      },
      swim: 30,
      canHover: true,
    },
    str: 19,
    dex: 10,
    con: 17,
    int: 16,
    wis: 13,
    cha: 17,
    save: {
      dex: "+2",
      con: "+5",
      wis: "+3",
      cha: "+5",
    },
    skill: {
      arcana: "+7",
      perception: "+5",
      persuasion: "+5",
      stealth: "+2",
    },
    senses: ["blindsight 10 ft.", "darkvision 120 ft."],
    passive: 15,
    resist: ["force", "psychic"],
    conditionImmune: ["frightened", "prone"],
    languages: ["Draconic", "telepathy 120 ft."],
    cr: "4",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 13}):",
        ],
        daily: {
          "1e": [
            "{@spell protection from evil and good}",
            "{@spell Tenser's floating disk}",
            "{@spell unseen servant}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon can breathe both air and water."],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}9 ({@damage 1d10 + 4}) piercing damage plus 4 ({@damage 1d8}) force damage.",
        ],
      },
      {
        name: "Singularity Breath {@recharge 5}",
        entries: [
          "The dragon creates a shining bead of gravitational force in its mouth, then releases the energy in a 15-foot cone. Each creature in that area must make a {@dc 13} Strength saving throw. On a failed save, the creature takes 22 ({@damage 5d8}) force damage, and its speed becomes 0 until the start of the dragon's next turn. On a successful save, the creature takes half as much damage, and its speed isn't reduced.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 11} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "wyrmling",
    traitTags: ["Amphibious"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon"],
    languageTags: ["DR", "TP"],
    damageTags: ["O", "P"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Amethyst Greatwyrm",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 201,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 21,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 507,
      formula: "26d20 + 234",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: {
        number: 120,
        condition: "(hover)",
      },
      swim: 60,
      canHover: true,
    },
    str: 28,
    dex: 14,
    con: 29,
    int: 30,
    wis: 24,
    cha: 25,
    save: {
      dex: "+10",
      con: "+17",
      wis: "+15",
      cha: "+15",
    },
    skill: {
      arcana: "+26",
      history: "+18",
      perception: "+15",
    },
    senses: ["truesight 120 ft."],
    passive: 25,
    immune: ["force"],
    conditionImmune: ["charmed", "frightened", "poisoned", "prone"],
    languages: ["Common", "Draconic"],
    cr: "26",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The greatwyrm casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 26}, {@hit 18} to hit with spell attack):",
        ],
        daily: {
          "1e": [
            "{@spell dispel magic}",
            "{@spell forcecage}",
            "{@spell plane shift}",
            "{@spell reverse gravity}",
            "{@spell time stop}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Gem Awakening (Recharges after a Short or Long Rest)",
        entries: [
          "If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 400 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use its Mass Telekinesis action during the next hour. Award a party an additional 90,000 XP (180,000 XP total) for defeating the greatwyrm after its Gem Awakening activates.",
        ],
      },
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 17} to hit, reach 15 ft., one target. {@h}20 ({@damage 2d10 + 9}) piercing damage plus 16 ({@damage 3d10}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 17} to hit, reach 10 ft., one target. {@h}18 ({@damage 2d8 + 9}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 19}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} in this way at a time.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm exhales crushing force in a 300-foot cone. Each creature in that area must make a {@dc 25} Dexterity saving throw. On a failed save, the creature takes 71 ({@damage 11d12}) force damage and is knocked {@condition prone}. On a successful save, it takes half as much damage and isn't knocked {@condition prone}. On a success or failure, the creature's speed becomes 0 until the end of its next turn.",
        ],
      },
      {
        name: "Mass Telekinesis (Gem Awakening Only; Recharges after a Short or Long Rest)",
        entries: [
          "The greatwyrm targets any number of creatures and objects it can see within 120 feet of it. No one target can weigh more than 4,000 pounds, and objects can't be targeted if they're being worn or carried. Each targeted creature must succeed on a {@dc 26} Strength saving throw or be {@condition restrained} in the greatwyrm's telekinetic grip. At the end of a creature's turn, it can repeat the saving throw, ending the effect on itself on a success.",
          "At the end of the greatwyrm's turn, it can move each creature or object it has in its telekinetic grip up to 60 feet in any direction, but not beyond 120 feet of itself. In addition, it can choose any number of creatures {@condition restrained} in this way and deal 45 ({@damage 7d12}) force damage to each of them.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The greatwyrm magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the greatwyrm is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The greatwyrm magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The greatwyrm makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The greatwyrm uses Psychic Step or Spellcasting."],
      },
      {
        name: "Psychic Beam (Costs 3 Actions)",
        entries: [
          "The greatwyrm emits a beam of psychic energy in a 90-foot line that is 10 feet wide. Each creature in that area must make a {@dc 26} Intelligence saving throw, taking 27 ({@damage 5d10}) psychic damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 15} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["O", "P", "S", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Ancient Amethyst Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 160,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 20,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 444,
      formula: "24d20 + 192",
    },
    speed: {
      walk: 40,
      fly: {
        number: 80,
        condition: "(hover)",
      },
      swim: 40,
      canHover: true,
    },
    str: 26,
    dex: 14,
    con: 27,
    int: 26,
    wis: 19,
    cha: 23,
    save: {
      dex: "+9",
      con: "+15",
      wis: "+11",
      cha: "+13",
    },
    skill: {
      arcana: "+22",
      perception: "+18",
      persuasion: "+13",
      stealth: "+9",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 28,
    resist: ["force", "psychic"],
    conditionImmune: ["frightened", "prone"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: {
      cr: "23",
      lair: "24",
    },
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 23}, {@hit 15} to hit with spell attacks):",
        ],
        daily: {
          "1e": [
            "{@spell blink}",
            "{@spell control water}",
            "{@spell dispel magic}",
            "{@spell freedom of movement}",
            "{@spell globe of invulnerability}",
            "{@spell plane shift}",
            "{@spell protection from evil and good}",
            "{@spell sending}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon can breathe both air and water."],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 15} to hit, reach 15 ft., one target. {@h}19 ({@damage 2d10 + 8}) piercing damage plus 13 ({@damage 3d8}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 15} to hit, reach 10 ft., one target. {@h}15 ({@damage 2d6 + 8}) slashing damage.",
        ],
      },
      {
        name: "Singularity Breath {@recharge 5}",
        entries: [
          "The dragon creates a shining bead of gravitational force in its mouth, then releases the energy in a 90-foot cone. Each creature in that area must make a {@dc 23} Strength saving throw. On a failed save, the creature takes 63 ({@damage 14d8}) force damage, and its speed becomes 0 until the start of the dragon's next turn. On a successful save, the creature takes half as much damage, and its speed isn't reduced.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The dragon magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The dragon makes one claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The dragon uses Psychic Step or Spellcasting."],
      },
      {
        name: "Explosive Crystal (Costs 3 Actions)",
        entries: [
          "The dragon spits an amethyst that that explodes at a point it can see within 60 feet of it. Each creature within a 20-foot-radius sphere centered on that point must succeed on a {@dc 23} Dexterity saving throw or take 18 ({@damage 4d8}) force damage and be knocked {@condition prone}.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Amethyst Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 14} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "ancient",
    traitTags: ["Amphibious", "Legendary Resistances"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["O", "P", "S"],
    damageTagsSpell: ["B"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["prone"],
    conditionInflictLegendary: ["charmed"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Ancient Crystal Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 170,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["C", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 20,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 222,
      formula: "12d20 + 96",
    },
    speed: {
      walk: 40,
      burrow: 40,
      climb: 40,
      fly: 80,
    },
    str: 25,
    dex: 12,
    con: 26,
    int: 20,
    wis: 16,
    cha: 21,
    save: {
      dex: "+7",
      con: "+14",
      wis: "+9",
      cha: "+11",
    },
    skill: {
      perception: "+15",
      stealth: "+13",
      survival: "+9",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 25,
    resist: ["cold", "radiant"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: {
      cr: "19",
      lair: "20",
    },
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 19}):",
        ],
        will: ["{@spell dancing lights}", "{@spell guidance}"],
        daily: {
          "1e": [
            "{@spell command}",
            "{@spell divination}",
            "{@spell greater restoration}",
            "{@spell hypnotic pattern}",
            "{@spell invisibility}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 13} to hit, reach 15 ft., one target. {@h}18 ({@damage 2d10 + 7}) piercing damage plus 9 ({@damage 2d8}) radiant damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 13} to hit, reach 10 ft., one target. {@h}14 ({@damage 2d6 + 7}) slashing damage.",
        ],
      },
      {
        name: "Scintillating Breath {@recharge 5}",
        entries: [
          "The dragon exhales a burst of brilliant radiance in a 90-foot cone. Each creature in that area must make a {@dc 22} Constitution saving throw, taking 49 ({@damage 11d8}) radiant damage on a failed save, or half as much damage on a successful one. The dragon then gains 25 temporary hit points by absorbing a portion of the radiant energy.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The dragon magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The dragon makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The dragon uses Psychic Step or Spellcasting."],
      },
      {
        name: "Starlight Strike (Costs 3 Actions)",
        entries: [
          "The dragon releases a searing beam of starlight at a creature that it can see within 60 feet of it. The target must succeed on a {@dc 19} Dexterity saving throw or take 38 ({@damage 11d6}) radiant damage.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Crystal Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 13} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "ancient",
    traitTags: ["Legendary Resistances"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["P", "R", "S"],
    damageTagsLegendary: ["R"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflictSpell: ["charmed", "incapacitated", "invisible", "prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Ancient Deep Dragon",
    source: "FTD",
    page: 173,
    size: ["G"],
    type: "dragon",
    alignment: ["N", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 20,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 201,
      formula: "13d20 + 65",
    },
    speed: {
      walk: 40,
      burrow: 40,
      fly: 80,
      swim: 40,
    },
    str: 23,
    dex: 16,
    con: 20,
    int: 19,
    wis: 18,
    cha: 21,
    save: {
      dex: "+9",
      con: "+11",
      wis: "+10",
      cha: "+11",
    },
    skill: {
      perception: "+10",
      persuasion: "+17",
      stealth: "+15",
    },
    senses: ["blindsight 60 ft.", "darkvision 300 ft."],
    passive: 20,
    resist: ["poison", "psychic"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic", "Undercommon"],
    cr: {
      cr: "18",
      lair: "19",
    },
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 10 ft., one target. {@h}17 ({@damage 2d10 + 6}) piercing damage plus 11 ({@damage 2d10}) poison damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 5 ft., one target. {@h}13 ({@damage 2d6 + 6}) slashing damage.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 15 ft., one target. {@h}10 ({@damage 1d8 + 6}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 20} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses its action to end it.",
        ],
      },
      {
        name: "Nightmare Breath {@recharge 5}",
        entries: [
          "The dragon exhales a cloud of spores in a 90-foot cone. Each creature in that area must make a {@dc 19} Wisdom saving throw. On a failed save, the creature takes 49 ({@damage 9d10}) psychic damage, and it is {@condition frightened} of the dragon for 1 minute. On a successful save, the creature takes half as much damage with no additional effects. A {@condition frightened} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
    ],
    legendary: [
      {
        name: "Commanding Spores",
        entries: [
          "The dragon releases spores around a creature within 30 feet of it that it can see. The target must succeed on a {@dc 19} Wisdom saving throw or use its reaction to make a melee weapon attack against a random creature within reach. If no creatures are within reach, or the target can't take a reaction, it takes 11 ({@damage 2d10}) psychic damage.",
        ],
      },
      {
        name: "Tail",
        entries: ["The dragon makes one Tail attack."],
      },
      {
        name: "Spore Salvo (Costs 2 Actions)",
        entries: [
          "The dragon releases poisonous spores around a creature within 30 feet of it that it can see. The target must succeed on a {@dc 19} Constitution saving throw or take 28 ({@damage 8d6}) poison damage and become {@condition poisoned} for 1 minute. The {@condition poisoned} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Deep Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 13} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "deep",
    dragonAge: "ancient",
    traitTags: ["Legendary Resistances"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "U"],
    damageTags: ["B", "I", "P", "S", "Y"],
    damageTagsLegendary: ["I"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["frightened", "poisoned", "prone"],
    conditionInflictLegendary: ["poisoned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Ancient Dragon Turtle",
    source: "FTD",
    page: 191,
    size: ["G"],
    type: "dragon",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 409,
      formula: "21d20 + 189",
    },
    speed: {
      walk: 30,
      swim: 60,
    },
    str: 28,
    dex: 12,
    con: 29,
    int: 14,
    wis: 19,
    cha: 15,
    save: {
      dex: "+8",
      con: "+16",
      wis: "+11",
    },
    skill: {
      perception: "+11",
    },
    senses: ["truesight 120 ft."],
    passive: 21,
    immune: ["cold", "fire"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Aquan", "Draconic"],
    cr: "24",
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon turtle can breathe air and water."],
      },
      {
        name: "Blessing of the Sea (Recharges after a Short or Long Rest)",
        entries: [
          'If the dragon turtle would be reduced to 0 hit points, its current hit point total instead resets to 350 hit points, and it recharges its Steam Breath. Additionally, the dragon turtle can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 62,000 XP (124,000 XP total) for defeating the dragon turtle after its Blessing of the Sea activates.',
        ],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon turtle fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The dragon turtle doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The dragon turtle makes one Bite or Tail attack and two Claw attacks.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 16} to hit, reach 15 ft., one target. {@h}15 ({@damage 1d12 + 9}) piercing damage plus 13 ({@damage 2d12}) lightning damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 16} to hit, reach 15 ft., one target. {@h}18 ({@damage 2d8 + 9}) slashing damage.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 16} to hit, reach 15 ft., one target. {@h}20 ({@damage 2d10 + 9}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 24} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Steam Breath {@recharge 5}",
        entries: [
          "The dragon turtle exhales steam in a 90-foot cone. Each creature in that area must make a {@dc 24} Constitution saving throw, taking 67 ({@damage 15d8}) fire damage on a failed save, or half as much damage on a successful one. Being underwater doesn't grant resistance against this damage.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The dragon turtle makes one Claw or Tail attack."],
      },
      {
        name: "Move",
        entries: [
          "The dragon turtle moves up to its speed. If the dragon turtle is swimming, this movement doesn't provoke opportunity attacks.",
        ],
      },
      {
        name: "Boiling Aura (Costs 3 Actions)",
        entries: [
          "The dragon turtle radiates intense heat. Until the start of the dragon turtle's next turn, whenever a creature starts its turn within 20 feet of the dragon turtle, that creature must succeed on a {@dc 24} Constitution saving throw or take 40 ({@damage 9d8}) fire damage. Being underwater doesn't grant resistance against this damage.",
        ],
      },
    ],
    mythicHeader: [
      "If the dragon turtle's Blessing of the Sea trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The dragon turtle makes one Bite attack."],
      },
      {
        name: "Armor of Storms (Costs 2 Actions)",
        entries: [
          "Lightning temporarily surrounds the dragon turtle, and it gains 40 temporary hit points until the start of its next turn. Until all these temporary hit points are gone, any creature that touches the dragon turtle or hits it with a melee attack takes 26 ({@damage 4d12}) lightning damage.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Ancient Dragon Turtle",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 10} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "ancient",
    traitTags: ["Amphibious", "Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["AQ", "DR"],
    damageTags: ["B", "F", "L", "P", "S"],
    damageTagsLegendary: ["F"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["prone"],
    conditionInflictLegendary: ["restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Ancient Emerald Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 195,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["L", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 20,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 332,
      formula: "19d20 + 133",
    },
    speed: {
      walk: 40,
      burrow: 30,
      fly: 80,
    },
    str: 25,
    dex: 12,
    con: 25,
    int: 20,
    wis: 18,
    cha: 20,
    save: {
      dex: "+8",
      con: "+14",
      wis: "+11",
      cha: "+12",
    },
    skill: {
      arcana: "+12",
      deception: "+12",
      perception: "+18",
      stealth: "+8",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 28,
    resist: ["fire", "psychic"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: {
      cr: "21",
      lair: "22",
    },
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 20}):",
        ],
        will: [
          "{@spell mage hand} (the hand is invisible)",
          "{@spell minor illusion}",
        ],
        daily: {
          "1e": [
            "{@spell detect thoughts}",
            "{@spell dispel magic}",
            "{@spell etherealness}",
            "{@spell major image}",
            "{@spell mislead}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Tunneler",
        entries: [
          "The dragon can burrow through solid rock at half its burrowing speed and can leave a 20-foot-diameter tunnel in its wake.",
        ],
      },
      {
        name: "Warp Perception (1/Day)",
        entries: [
          "The dragon can cast {@spell mirage arcane}, requiring no spell components and using Intelligence as the spellcasting ability.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 14} to hit, reach 15 ft., one target. {@h}18 ({@damage 2d10 + 7}) piercing damage plus 10 ({@damage 3d6}) psychic damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 14} to hit, reach 10 ft., one target. {@h}14 ({@damage 2d6 + 7}) slashing damage.",
        ],
      },
      {
        name: "Disorienting Breath {@recharge 5}",
        entries: [
          "The dragon exhales a wave of psychic dissonance in a 90-foot cone. Each creature in that area must make a {@dc 22} Intelligence saving throw. On a failed save, the creature takes 56 ({@damage 16d6}) psychic damage, and until the end of its next turn, when the creature makes an attack roll or an ability check, it must roll a {@dice d8} and reduce the total by the number rolled. On a successful save, the creature takes half as much damage with no additional effects.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The dragon magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The dragon makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The dragon uses Psychic Step or Spellcasting."],
      },
      {
        name: "Emerald Embers (Costs 3 Actions)",
        entries: [
          "The dragon creates a dancing mote of green flame around a creature it can see within 60 feet of it. The target must succeed on a {@dc 20} Dexterity saving throw or take 42 ({@damage 12d6}) fire damage.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Emerald Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 20} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "ancient",
    traitTags: ["Legendary Resistances", "Tunneler"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["F", "P", "S", "Y"],
    damageTagsLegendary: ["Y"],
    damageTagsSpell: ["O"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflictSpell: ["blinded", "deafened", "invisible"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Ancient Moonstone Dragon",
    source: "FTD",
    page: 211,
    size: ["G"],
    type: "dragon",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 20,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 330,
      formula: "20d20 + 120",
    },
    speed: {
      walk: 40,
      fly: 80,
    },
    str: 22,
    dex: 18,
    con: 23,
    int: 20,
    wis: 22,
    cha: 26,
    save: {
      int: "+12",
      wis: "+13",
      cha: "+15",
    },
    skill: {
      perception: "+13",
      persuasion: "+15",
      stealth: "+11",
    },
    senses: ["truesight 120 ft."],
    passive: 23,
    conditionImmune: ["charmed"],
    languages: ["all", "telepathy 120 ft."],
    cr: {
      cr: "21",
      lair: "22",
    },
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 23}):",
        ],
        will: ["{@spell faerie fire}"],
        daily: {
          "2e": [
            "{@spell calm emotions}",
            "{@spell dispel magic}",
            "{@spell invisibility}",
            "{@spell revivify}",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 13} to hit, reach 15 ft., one target. {@h}17 ({@damage 2d10 + 6}) piercing damage plus 11 ({@damage 2d10}) radiant damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 13} to hit, reach 10 ft., one target. {@h}13 ({@damage 2d6 + 6}) slashing damage.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 13} to hit, reach 20 ft., one target. {@h}10 ({@damage 1d8 + 6}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 21} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The dragon uses one of the following breath weapons:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                type: "item",
                name: "Dream Breath",
                entries: [
                  "The dragon exhales mist in a 90-foot cone. Each creature in that area must succeed on a {@dc 21} Constitution saving throw or fall {@condition unconscious} for 10 minutes. This effect ends for a creature if the creature takes damage or someone uses an action to wake it.",
                ],
              },
              {
                type: "item",
                name: "Moonlight Breath",
                entries: [
                  "The dragon exhales a beam of moonlight in a 120-foot line that is 10 feet wide. Each creature in that area must make a {@dc 21} Dexterity saving throw, taking 60 ({@damage 11d10}) radiant damage on a failed save, or half as much damage on a successful one.",
                ],
              },
            ],
          },
        ],
      },
    ],
    legendary: [
      {
        name: "Tail",
        entries: ["The dragon makes one Tail attack."],
      },
      {
        name: "Cast a Spell (Costs 2 Actions)",
        entries: ["The dragon uses Spellcasting."],
      },
    ],
    legendaryGroup: {
      name: "Moonstone Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 16} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "ancient",
    traitTags: ["Legendary Resistances"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["TP", "XX"],
    damageTags: ["B", "P", "R", "S"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["prone", "unconscious"],
    conditionInflictLegendary: ["incapacitated", "stunned"],
    conditionInflictSpell: ["invisible"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Ancient Sapphire Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 214,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["L", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 20,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 370,
      formula: "20d20 + 160",
    },
    speed: {
      walk: 40,
      burrow: 40,
      climb: 40,
      fly: 80,
    },
    str: 27,
    dex: 14,
    con: 27,
    int: 21,
    wis: 19,
    cha: 20,
    save: {
      dex: "+9",
      con: "+15",
      wis: "+11",
      cha: "+12",
    },
    skill: {
      history: "+12",
      perception: "+18",
      persuasion: "+19",
      stealth: "+9",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 28,
    resist: ["lightning", "thunder"],
    conditionImmune: ["frightened"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: {
      cr: "22",
      lair: "23",
    },
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 20}):",
        ],
        daily: {
          "1e": [
            "{@spell dissonant whispers}",
            "{@spell hold monster}",
            "{@spell meld into stone}",
            "{@spell telekinesis}",
            "{@spell teleport}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Spider Climb",
        entries: [
          "The dragon can climb difficult surfaces, including upside down on ceilings, without needing to make an ability check.",
        ],
      },
      {
        name: "Tunneler",
        entries: [
          "The dragon can burrow through solid rock at half its burrowing speed and can leave a 20-foot-diameter tunnel in its wake.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 15} to hit, reach 15 ft., one target. {@h}19 ({@damage 2d10 + 8}) piercing damage plus 11 ({@damage 2d10}) thunder damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 15} to hit, reach 10 ft., one target. {@h}15 ({@damage 2d6 + 8}) slashing damage.",
        ],
      },
      {
        name: "Debilitating Breath {@recharge 5}",
        entries: [
          "The dragon exhales a pulse of high-pitched, nearly inaudible sound in a 90-foot cone. Each creature in that area must make a {@dc 23} Constitution saving throw. On a failed save, the creature takes 55 ({@damage 10d10}) thunder damage and is {@condition incapacitated} until the end of its next turn. On a successful save, the creature takes half as much damage and isn't {@condition incapacitated}.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The dragon magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The dragon makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The dragon uses Psychic Step or Spellcasting."],
      },
      {
        name: "Telekinetic Fling (Costs 3 Actions)",
        entries: [
          "The dragon chooses one Medium or smaller object that isn't being worn or carried that it can see within 60 feet of it, and it magically hurls the object at a creature it can see within 60 feet of the object. The target must succeed on a {@dc 20} Dexterity saving throw or take 42 ({@damage 12d6}) bludgeoning damage.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Sapphire Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 13} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "ancient",
    traitTags: ["Legendary Resistances", "Spider Climb", "Tunneler"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["B", "P", "S", "T"],
    damageTagsLegendary: ["T"],
    damageTagsSpell: ["B", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["incapacitated"],
    conditionInflictLegendary: ["charmed", "stunned"],
    conditionInflictSpell: ["paralyzed", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Ancient Sea Serpent",
    source: "FTD",
    page: 219,
    size: ["G"],
    type: "dragon",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 170,
      formula: "11d20 + 55",
    },
    speed: {
      walk: 20,
      swim: 60,
    },
    str: 24,
    dex: 15,
    con: 20,
    int: 13,
    wis: 16,
    cha: 12,
    save: {
      str: "+12",
      con: "+10",
    },
    skill: {
      perception: "+8",
      stealth: "+7",
    },
    senses: ["darkvision 120 ft."],
    passive: 18,
    immune: ["cold"],
    languages: ["Common", "Draconic"],
    cr: "14",
    trait: [
      {
        name: "Amphibious",
        entries: ["The sea serpent can breathe air and water."],
      },
      {
        name: "Legendary Resistance (2/Day)",
        entries: [
          "If the sea serpent fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Siege Monster",
        entries: [
          "The sea serpent deals double damage to objects and structures.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The sea serpent makes one Bite attack and one Constrict or Tail attack.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 15 ft., one target. {@h}20 ({@damage 2d12 + 7}) piercing damage plus 6 ({@damage 1d12}) cold damage.",
        ],
      },
      {
        name: "Constrict",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 20 ft., one creature. {@h}29 ({@damage 4d10 + 7}) bludgeoning damage, and the target is {@condition grappled} (escape {@dc 20}). Until this grapple ends, the target is {@condition restrained}, and the sea serpent can't constrict another target.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 20 ft., one target. {@h}13 ({@damage 1d12 + 7}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 20} Strength saving throw or be pushed up to 30 feet away from the sea serpent and knocked {@condition prone}.",
        ],
      },
      {
        name: "Rime Breath {@recharge 5}",
        entries: [
          "The sea serpent exhales a 60-foot cone of cold. Each creature in that area must make a {@dc 18} Constitution saving throw, taking 49 ({@damage 9d10}) cold damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    legendary: [
      {
        name: "Tail",
        entries: ["The sea serpent makes one Tail attack."],
      },
      {
        name: "Bite (Costs 2 Actions)",
        entries: ["The sea serpent makes one Bite attack"],
      },
    ],
    dragonAge: "ancient",
    traitTags: ["Amphibious", "Legendary Resistances", "Siege Monster"],
    senseTags: ["SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "C", "P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Ancient Topaz Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 220,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["C", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 20,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 280,
      formula: "17d20 + 102",
    },
    speed: {
      walk: 40,
      fly: 80,
      swim: 40,
    },
    str: 23,
    dex: 12,
    con: 23,
    int: 20,
    wis: 19,
    cha: 20,
    save: {
      dex: "+7",
      con: "+12",
      wis: "+10",
      cha: "+11",
    },
    skill: {
      intimidation: "+17",
      perception: "+16",
      stealth: "+7",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 26,
    resist: ["cold", "necrotic"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: {
      cr: "20",
      lair: "21",
    },
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 19}):",
        ],
        daily: {
          "1e": [
            "{@spell antilife shell}",
            "{@spell bane}",
            "{@spell control water}",
            "{@spell create or destroy water}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon can breathe both air and water."],
      },
      {
        name: "Fabricate (1/Day)",
        entries: [
          "The dragon can cast {@spell fabricate}, requiring no spell components and using Intelligence as the spellcasting ability.",
        ],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 15 ft., one target. {@h}17 ({@damage 2d10 + 6}) piercing damage plus 10 ({@damage 3d6}) necrotic damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 10 ft., one target. {@h}13 ({@damage 2d6 + 6}) slashing damage.",
        ],
      },
      {
        name: "Desiccating Breath {@recharge 5}",
        entries: [
          "The dragon exhales yellowish necrotic energy in a 90-foot cone. Each creature in that area must make a {@dc 20} Constitution saving throw. On a failed save, the creature takes 49 ({@damage 14d6}) necrotic damage and is weakened until the end of its next turn. A weakened creature has disadvantage on Strength-based ability checks and Strength saving throws, and the creature's weapon attacks that rely on Strength deal half damage. On a successful save, the creature takes half as much damage and isn't weakened.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The dragon magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The dragon magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The dragon makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The dragon uses Psychic Step or Spellcasting."],
      },
      {
        name: "Essential Reduction (Costs 3 Actions)",
        entries: [
          "The dragon targets a creature or an object not being worn or carried that it can see within 60 feet of it. The target must succeed on a {@dc 19} Constitution saving throw or take 40 ({@damage 9d8}) necrotic damage. If this damage reduces the target to 0 hit points, it crumbles to dust.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Topaz Dragon",
      source: "FTD",
    },
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 13} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "ancient",
    traitTags: ["Amphibious", "Legendary Resistances"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["N", "P", "S"],
    damageTagsLegendary: ["N"],
    damageTagsSpell: ["B"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Animated Breath",
    source: "FTD",
    page: 163,
    size: ["L"],
    type: "elemental",
    alignment: ["N", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
      {
        ac: 17,
        condition: "cold form only",
        braces: true,
      },
    ],
    hp: {
      average: 95,
      formula: "10d10 + 40",
    },
    speed: {
      walk: 30,
      fly: {
        number: 30,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 19,
    dex: 11,
    con: 18,
    int: 6,
    wis: 10,
    cha: 5,
    senses: ["darkvision 60 ft."],
    passive: 10,
    resist: [
      {
        special:
          "damage of the type matching the animated breath's form (acid, cold, fire, lightning, or poison)",
      },
    ],
    conditionImmune: [
      "exhaustion",
      "paralyzed",
      "petrified",
      "poisoned",
      "restrained",
      "unconscious",
    ],
    languages: ["understands Draconic but can't speak"],
    cr: "6",
    trait: [
      {
        name: "Chromatic Form",
        entries: [
          "When created, the animated breath takes one of five forms, matching its creator's breath weapon: Acid, Cold, Fire, Lightning, or Poison. This form determines the creature's AC, damage resistance, traits, and attacks.",
        ],
      },
      {
        name: "Fire Aura (Fire Form Only)",
        entries: [
          "At the start of each of the animated breath's turns, each creature within 5 feet of it takes 3 ({@damage 1d6}) fire damage, and flammable objects in the aura that aren't being worn or carried ignite. A creature that touches the animated breath or hits it with a melee attack takes 3 ({@damage 1d6}) fire damage.",
        ],
      },
      {
        name: "Putrid Aura (Acid and Poison Forms Only)",
        entries: [
          "A creature that starts its turn within 5 feet of the animated breath must succeed on a {@dc 15} Constitution saving throw or be {@condition poisoned} until the start of its next turn. A creature that touches the animated breath or hits it with a melee attack takes 3 ({@damage 1d6}) acid damage.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The animated breath makes two Slam attacks."],
      },
      {
        name: "Slam",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}13 ({@damage 2d8 + 4}) bludgeoning damage plus 11 ({@damage 2d10}) damage of a type determined by the animated breath's form: acid, cold, fire, lightning, or poison.",
        ],
      },
    ],
    bonus: [
      {
        name: "Lightning Burst (Lightning Form Only)",
        entries: [
          "The animated breath magically teleports to an unoccupied space it can see within 30 feet of it. Each creature within 5 feet of the animated breath after it teleports takes 3 ({@damage 1d6}) lightning damage.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS", "DR"],
    damageTags: ["A", "B", "F", "L"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["poisoned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Aspect of Bahamut",
    source: "FTD",
    page: 165,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["metallic"],
    },
    alignment: ["L", "G"],
    ac: [
      {
        ac: 23,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 585,
      formula: "30d20 + 270",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 18,
    con: 29,
    int: 25,
    wis: 28,
    cha: 30,
    save: {
      con: "+18",
      int: "+16",
      wis: "+18",
      cha: "+19",
    },
    skill: {
      insight: "+18",
      perception: "+18",
      persuasion: "+19",
    },
    senses: ["truesight 120 ft."],
    passive: 28,
    immune: [
      "acid",
      "cold",
      "fire",
      "lightning",
      "radiant",
      {
        immune: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    conditionImmune: [
      "charmed",
      "deafened",
      "frightened",
      "paralyzed",
      "stunned",
    ],
    languages: ["Common", "Draconic"],
    cr: "30",
    trait: [
      {
        name: "Platinum Brilliance (Recharges after a Short or Long Rest)",
        entries: [
          'If the aspect would be reduced to 0 hit points, his current hit point total instead resets to 500 hit points, he recharges his Breath Weapon, and he regains any expended uses of Legendary Resistance. Additionally, the aspect can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 155,000 XP (310,000 XP total) for defeating the aspect of Bahamut after his Platinum Brilliance activates.',
        ],
      },
      {
        name: "Legendary Resistance (5/Day)",
        entries: [
          "If the aspect fails a saving throw, he can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The aspect makes one Bite attack, one Claw attack, and one Tail attack.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 19} to hit, reach 20 ft., one target. {@h}23 ({@damage 2d12 + 10}) piercing damage plus 22 ({@damage 4d10}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 19} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The aspect can have only one creature {@condition grappled} this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 19} to hit, reach 15 ft., one target. {@h}23 ({@damage 2d12 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 27} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The aspect uses one of the following breath weapons:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                type: "item",
                name: "Exalting Breath",
                entries: [
                  "The aspect exhales the restoring winds of Mount Celestia in a 300-foot cone. Each creature in that area of the aspect's choice regains 71 ({@dice 13d10}) hit points, and each creature in that area of the aspect's choice that has been dead for no longer than 1 hour is restored to life with all its hit points.",
                ],
              },
              {
                type: "item",
                name: "Platinum Breath",
                entries: [
                  "The aspect exhales radiant platinum flames in a 300-foot cone. Each creature in that area must make a {@dc 26} Dexterity saving throw, taking 66 ({@damage 12d10}) radiant damage on a failed save, or half as much damage on a successful one.",
                ],
              },
            ],
          },
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The aspect magically transforms into any Humanoid or Beast, while retaining his game statistics (other than his size). This transformation ends if the aspect is reduced to 0 hit points or if he uses a bonus action to end it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The aspect makes one Claw or Tail attack."],
      },
      {
        name: "Furious Bite (Costs 2 Actions)",
        entries: [
          "The aspect makes one Bite attack. If the attack hits a creature, the target must succeed on a {@dc 27} Wisdom saving throw or become {@condition frightened} of the aspect until the end of the target's next turn.",
        ],
      },
    ],
    mythicHeader: [
      "If the aspect's Platinum Brilliance trait has activated in the last hour, he can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Celestial Shield (Costs 2 Actions)",
        entries: [
          "The aspect manifests seven spectral {@creature ancient gold dragon||ancient gold dragons} around himself that protect him; he gains 77 temporary hit points until the start of his next turn.",
        ],
      },
      {
        name: "Celestial Lances (Costs 3 Actions)",
        entries: [
          "The aspect conjures four enormous lances of magical force that plummet to the ground at four different points he can see within 150 feet of him and then disappear. Each creature in a 20-foot-radius, 100-foot-high cylinder centered on each point must succeed on a {@dc 27} Dexterity saving throw or take 24 ({@damage 7d6}) force damage. A creature in the area of more than one lance is affected only once.",
        ],
      },
    ],
    dragonAge: "aspect",
    traitTags: ["Legendary Resistances"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "O", "P", "R", "S"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["frightened", "grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Aspect of Tiamat",
    source: "FTD",
    page: 166,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["chromatic"],
    },
    alignment: ["C", "E"],
    ac: [
      {
        ac: 23,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 574,
      formula: "28d20 + 280",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 14,
    con: 30,
    int: 21,
    wis: 20,
    cha: 26,
    save: {
      dex: "+11",
      con: "+19",
      wis: "+14",
      cha: "+17",
    },
    skill: {
      intimidation: "+26",
      perception: "+23",
    },
    senses: ["truesight 120 ft."],
    passive: 33,
    immune: [
      "acid",
      "cold",
      "fire",
      "lightning",
      "poison",
      {
        immune: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    conditionImmune: [
      "blinded",
      "charmed",
      "deafened",
      "frightened",
      "poisoned",
      "stunned",
    ],
    languages: ["Common", "Draconic", "Infernal"],
    cr: "30",
    trait: [
      {
        name: "Chromatic Wrath (Recharges after a Short or Long Rest)",
        entries: [
          'If the aspect would be reduced to 0 hit points, her current hit point total instead resets to 500 hit points, she recharges her Chromatic Flames, and she regains any expended uses of Legendary Resistance. Additionally, the aspect can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 155,000 XP (310,000 XP total) for defeating the aspect of Tiamat after her Chromatic Wrath activates.',
        ],
      },
      {
        name: "Legendary Resistance (5/Day)",
        entries: [
          "If the aspect fails a saving throw, she can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The aspect makes one Bite attack, one Claw attack, and one Tail attack.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 19} to hit, reach 20 ft., one target. {@h}23 ({@damage 2d12 + 10}) piercing damage plus 19 ({@damage 3d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 19} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The aspect can have only one creature {@condition grappled} this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 19} to hit, reach 15 ft., one target. {@h}23 ({@dice 2d12 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 27} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Chromatic Flames {@recharge 5}",
        entries: [
          "The aspect exhales multicolored flames in a 300-foot cone. Each creature in that area must make a {@dc 27} Dexterity saving throw. On a failed save, the creature takes 71 ({@damage 11d12}) damage of a type of the aspect's choosing: acid, cold, fire, lightning, or poison. On a successful save, the creature takes half as much damage.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The aspect makes one Claw or Tail attack."],
      },
      {
        name: "Furious Bite (Costs 2 Actions)",
        entries: [
          "The aspect makes one Bite attack. If the attack hits a creature, the target must succeed on a {@dc 27} Wisdom saving throw or become {@condition frightened} of the aspect until the end of its next turn.",
        ],
      },
    ],
    mythicHeader: [
      "If the aspect's Chromatic Wrath trait has activated in the last hour, she can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Hurl Through Avernus (Costs 2 Actions)",
        entries: [
          "The aspect targets a creature she is grappling. The creature must succeed on a {@dc 25} Charisma saving throw or take 44 ({@damage 8d10}) psychic damage and be banished to Avernus (the first layer of the Nine Hells). At the start of the aspect's next turn, the creature reappears in an unoccupied space within 10 feet of the aspect.",
        ],
      },
      {
        name: "Chromatic Flare (Costs 3 Actions)",
        entries: [
          "The aspect flares with elemental energy. Each creature of the aspect's choice in a 60-foot-radius sphere centered on her must make a {@dc 27} Dexterity saving throw. On a failed save, the creature takes 39 ({@damage 6d12}) damage of a type chosen by the aspect: acid, cold, fire, lightning, or poison. On a successful save, the creature takes half as much damage.",
        ],
      },
    ],
    dragonAge: "aspect",
    traitTags: ["Legendary Resistances"],
    senseTags: ["U"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR", "I"],
    damageTags: ["O", "P", "S", "Y"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["frightened", "grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Black Greatwyrm",
    group: ["Chromatic Dragon"],
    source: "FTD",
    page: 168,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["chromatic"],
    },
    alignment: ["C", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 533,
      formula: "26d20 + 260",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 14,
    con: 30,
    int: 21,
    wis: 20,
    cha: 26,
    save: {
      dex: "+10",
      con: "+18",
      wis: "+13",
      cha: "+16",
    },
    skill: {
      intimidation: "+16",
      perception: "+21",
      stealth: "+10",
    },
    senses: ["truesight 120 ft."],
    passive: 31,
    immune: ["acid"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic"],
    cr: "27",
    trait: [
      {
        name: "Chromatic Awakening (Recharges after a Short or Long Rest)",
        entries: [
          'If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 425 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 105,000 XP (210,000 XP total) for defeating the greatwyrm after its Chromatic Awakening activates.',
        ],
      },
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) piercing damage plus 13 ({@damage 2d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 20 ft., one target. {@h}19 ({@damage 2d8 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 26} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm exhales a blast of energy in a 300-foot cone. Each creature in that area must make a {@dc 26} Dexterity saving throw. On a failed save, the creature takes 78 ({@damage 12d12}) acid damage. On a successful save, the creature takes half as much damage.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The greatwyrm makes one Claw or Tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "The greatwyrm beats its wings. Each creature within 30 feet of it must succeed on a {@dc 26} Dexterity saving throw or take 17 ({@damage 2d6 + 10}) bludgeoning damage and be knocked {@condition prone}. The greatwyrm can then fly up to half its flying speed.",
        ],
      },
      {
        name: "Arcane Spear (Costs 3 Actions)",
        entries: [
          "The greatwyrm creates four spears of magical force. Each spear hits a creature of the greatwyrm's choice it can see within 120 feet of it, dealing 12 ({@damage 1d8 + 8}) force damage to its target, then disappears.",
        ],
      },
    ],
    mythicHeader: [
      "If the greatwyrm's Chromatic Awakening trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The greatwyrm makes one Bite attack."],
      },
      {
        name: "Chromatic Flare (Costs 2 Actions)",
        entries: [
          "The greatwyrm flares with elemental energy. Each creature in a 60-foot-radius sphere centered on the greatwyrm must succeed on a {@dc 26} Dexterity saving throw or take 22 ({@damage 5d8}) acid damage.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 16} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "black",
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["A", "B", "O", "P", "S"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Blue Greatwyrm",
    group: ["Chromatic Dragon"],
    source: "FTD",
    page: 168,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["chromatic"],
    },
    alignment: ["C", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 533,
      formula: "26d20 + 260",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 14,
    con: 30,
    int: 21,
    wis: 20,
    cha: 26,
    save: {
      dex: "+10",
      con: "+18",
      wis: "+13",
      cha: "+16",
    },
    skill: {
      intimidation: "+16",
      perception: "+21",
      stealth: "+10",
    },
    senses: ["truesight 120 ft."],
    passive: 31,
    immune: ["lightning"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic"],
    cr: "27",
    trait: [
      {
        name: "Chromatic Awakening (Recharges after a Short or Long Rest)",
        entries: [
          'If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 425 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 105,000 XP (210,000 XP total) for defeating the greatwyrm after its Chromatic Awakening activates.',
        ],
      },
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) piercing damage plus 13 ({@damage 2d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 20 ft., one target. {@h}19 ({@damage 2d8 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 26} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm exhales a blast of energy in a 300-foot cone. Each creature in that area must make a {@dc 26} Dexterity saving throw. On a failed save, the creature takes 78 ({@damage 12d12}) lightning damage. On a successful save, the creature takes half as much damage.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The greatwyrm makes one Claw or Tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "The greatwyrm beats its wings. Each creature within 30 feet of it must succeed on a {@dc 26} Dexterity saving throw or take 17 ({@damage 2d6 + 10}) bludgeoning damage and be knocked {@condition prone}. The greatwyrm can then fly up to half its flying speed.",
        ],
      },
      {
        name: "Arcane Spear (Costs 3 Actions)",
        entries: [
          "The greatwyrm creates four spears of magical force. Each spear hits a creature of the greatwyrm's choice it can see within 120 feet of it, dealing 12 ({@damage 1d8 + 8}) force damage to its target, then disappears.",
        ],
      },
    ],
    mythicHeader: [
      "If the greatwyrm's Chromatic Awakening trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The greatwyrm makes one Bite attack."],
      },
      {
        name: "Chromatic Flare (Costs 2 Actions)",
        entries: [
          "The greatwyrm flares with elemental energy. Each creature in a 60-foot-radius sphere centered on the greatwyrm must succeed on a {@dc 26} Dexterity saving throw or take 22 ({@damage 5d8}) lightning damage.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 16} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "blue",
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "L", "O", "P", "S"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Brass Greatwyrm",
    group: ["Metallic Dragon"],
    source: "FTD",
    page: 208,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["metallic"],
    },
    alignment: ["L", "G"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 565,
      formula: "29d20 + 261",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 16,
    con: 29,
    int: 21,
    wis: 22,
    cha: 30,
    save: {
      dex: "+11",
      con: "+17",
      int: "+13",
      wis: "+14",
      cha: "+18",
    },
    skill: {
      insight: "+14",
      perception: "+22",
      persuasion: "+18",
    },
    senses: ["truesight 120 ft."],
    passive: 32,
    immune: ["fire"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic"],
    cr: "28",
    trait: [
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Metallic Awakening (Recharges after a Short or Long Rest)",
        entries: [
          'If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 450 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 120,000 XP (240,000 XP total) for defeating the greatwyrm after its Metallic Awakening activates.',
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) piercing damage plus 13 ({@damage 2d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} in this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 20 ft., one target. {@h}21 ({@damage 2d10 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 26} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm uses one of the following breath weapons:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                type: "item",
                name: "Elemental Breath",
                entries: [
                  "The greatwyrm exhales elemental energy in a 300-foot cone. Each creature in that area must make a {@dc 25} Dexterity saving throw, taking 84 ({@damage 13d12}) fire damage on a failed save, or half as much damage on a successful one.",
                ],
              },
              {
                type: "item",
                name: "Sapping Breath",
                entries: [
                  "The greatwyrm exhales gas in a 300-foot cone. Each creature in that area must make a {@dc 25} Constitution saving throw. On a failed save, the creature falls {@condition unconscious} for 1 minute. On a successful save, the creature has disadvantage on attack rolls and saving throws until the end of the greatwyrm's next turn. An {@condition unconscious} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
                ],
              },
            ],
          },
        ],
      },
      {
        name: "Change Shape",
        entries: [
          "The greatwyrm magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses its action to end it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The greatwyrm makes one Claw or Tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "The greatwyrm beats its wings. Each creature within 30 feet of it must succeed on a {@dc 26} Dexterity saving throw or take 17 ({@damage 2d6 + 10}) bludgeoning damage and be knocked {@condition prone}. The greatwyrm can then fly up to half its flying speed.",
        ],
      },
    ],
    mythicHeader: [
      "If the greatwyrm's Metallic Awakening trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The greatwyrm makes one Bite attack."],
      },
      {
        name: "Shattering Roar (Costs 2 Actions)",
        entries: [
          "The greatwyrm unleashes a magical roar. Each creature in a 120-foot-radius sphere centered on the greatwyrm must succeed on a {@dc 26} Constitution saving throw or take 19 ({@damage 3d12}) thunder damage and be {@condition incapacitated} until the end of its next turn.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 18} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "brass",
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "F", "O", "P", "S", "T"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: [
      "grappled",
      "incapacitated",
      "prone",
      "restrained",
      "unconscious",
    ],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Bronze Greatwyrm",
    group: ["Metallic Dragon"],
    source: "FTD",
    page: 208,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["metallic"],
    },
    alignment: ["L", "G"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 565,
      formula: "29d20 + 261",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 16,
    con: 29,
    int: 21,
    wis: 22,
    cha: 30,
    save: {
      dex: "+11",
      con: "+17",
      int: "+13",
      wis: "+14",
      cha: "+18",
    },
    skill: {
      insight: "+14",
      perception: "+22",
      persuasion: "+18",
    },
    senses: ["truesight 120 ft."],
    passive: 32,
    immune: ["lightning"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic"],
    cr: "28",
    trait: [
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Metallic Awakening (Recharges after a Short or Long Rest)",
        entries: [
          'If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 450 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 120,000 XP (240,000 XP total) for defeating the greatwyrm after its Metallic Awakening activates.',
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) piercing damage plus 13 ({@damage 2d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} in this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 20 ft., one target. {@h}21 ({@damage 2d10 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 26} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm uses one of the following breath weapons:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                type: "item",
                name: "Elemental Breath",
                entries: [
                  "The greatwyrm exhales elemental energy in a 300-foot cone. Each creature in that area must make a {@dc 25} Dexterity saving throw, taking 84 ({@damage 13d12}) lightning damage on a failed save, or half as much damage on a successful one.",
                ],
              },
              {
                type: "item",
                name: "Sapping Breath",
                entries: [
                  "The greatwyrm exhales gas in a 300-foot cone. Each creature in that area must make a {@dc 25} Constitution saving throw. On a failed save, the creature falls {@condition unconscious} for 1 minute. On a successful save, the creature has disadvantage on attack rolls and saving throws until the end of the greatwyrm's next turn. An {@condition unconscious} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
                ],
              },
            ],
          },
        ],
      },
      {
        name: "Change Shape",
        entries: [
          "The greatwyrm magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses its action to end it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The greatwyrm makes one Claw or Tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "The greatwyrm beats its wings. Each creature within 30 feet of it must succeed on a {@dc 26} Dexterity saving throw or take 17 ({@damage 2d6 + 10}) bludgeoning damage and be knocked {@condition prone}. The greatwyrm can then fly up to half its flying speed.",
        ],
      },
    ],
    mythicHeader: [
      "If the greatwyrm's Metallic Awakening trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The greatwyrm makes one Bite attack."],
      },
      {
        name: "Shattering Roar (Costs 2 Actions)",
        entries: [
          "The greatwyrm unleashes a magical roar. Each creature in a 120-foot-radius sphere centered on the greatwyrm must succeed on a {@dc 26} Constitution saving throw or take 19 ({@damage 3d12}) thunder damage and be {@condition incapacitated} until the end of its next turn.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 18} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "bronze",
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "L", "O", "P", "S", "T"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: [
      "grappled",
      "incapacitated",
      "prone",
      "restrained",
      "unconscious",
    ],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Copper Greatwyrm",
    group: ["Metallic Dragon"],
    source: "FTD",
    page: 208,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["metallic"],
    },
    alignment: ["L", "G"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 565,
      formula: "29d20 + 261",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 16,
    con: 29,
    int: 21,
    wis: 22,
    cha: 30,
    save: {
      dex: "+11",
      con: "+17",
      int: "+13",
      wis: "+14",
      cha: "+18",
    },
    skill: {
      insight: "+14",
      perception: "+22",
      persuasion: "+18",
    },
    senses: ["truesight 120 ft."],
    passive: 32,
    immune: ["acid"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic"],
    cr: "28",
    trait: [
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Metallic Awakening (Recharges after a Short or Long Rest)",
        entries: [
          'If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 450 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 120,000 XP (240,000 XP total) for defeating the greatwyrm after its Metallic Awakening activates.',
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) piercing damage plus 13 ({@damage 2d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} in this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 20 ft., one target. {@h}21 ({@damage 2d10 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 26} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm uses one of the following breath weapons:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                type: "item",
                name: "Elemental Breath",
                entries: [
                  "The greatwyrm exhales elemental energy in a 300-foot cone. Each creature in that area must make a {@dc 25} Dexterity saving throw, taking 84 ({@damage 13d12}) acid damage on a failed save, or half as much damage on a successful one.",
                ],
              },
              {
                type: "item",
                name: "Sapping Breath",
                entries: [
                  "The greatwyrm exhales gas in a 300-foot cone. Each creature in that area must make a {@dc 25} Constitution saving throw. On a failed save, the creature falls {@condition unconscious} for 1 minute. On a successful save, the creature has disadvantage on attack rolls and saving throws until the end of the greatwyrm's next turn. An {@condition unconscious} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
                ],
              },
            ],
          },
        ],
      },
      {
        name: "Change Shape",
        entries: [
          "The greatwyrm magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses its action to end it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The greatwyrm makes one Claw or Tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "The greatwyrm beats its wings. Each creature within 30 feet of it must succeed on a {@dc 26} Dexterity saving throw or take 17 ({@damage 2d6 + 10}) bludgeoning damage and be knocked {@condition prone}. The greatwyrm can then fly up to half its flying speed.",
        ],
      },
    ],
    mythicHeader: [
      "If the greatwyrm's Metallic Awakening trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The greatwyrm makes one Bite attack."],
      },
      {
        name: "Shattering Roar (Costs 2 Actions)",
        entries: [
          "The greatwyrm unleashes a magical roar. Each creature in a 120-foot-radius sphere centered on the greatwyrm must succeed on a {@dc 26} Constitution saving throw or take 19 ({@damage 3d12}) thunder damage and be {@condition incapacitated} until the end of its next turn.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 18} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "copper",
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["A", "B", "O", "P", "S", "T"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: [
      "grappled",
      "incapacitated",
      "prone",
      "restrained",
      "unconscious",
    ],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Crystal Dragon Wyrmling",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 172,
    size: ["M"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["C", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 32,
      formula: "5d8 + 10",
    },
    speed: {
      walk: 30,
      burrow: 15,
      climb: 30,
      fly: 60,
    },
    str: 14,
    dex: 12,
    con: 14,
    int: 14,
    wis: 13,
    cha: 15,
    save: {
      dex: "+3",
      con: "+4",
      wis: "+3",
      cha: "+4",
    },
    skill: {
      perception: "+5",
      stealth: "+5",
      survival: "+3",
    },
    senses: ["blindsight 10 ft.", "darkvision 60 ft."],
    passive: 15,
    resist: ["cold", "radiant"],
    languages: ["Draconic", "telepathy 120 ft."],
    cr: "2",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability:",
        ],
        will: ["{@spell dancing lights}", "{@spell guidance}"],
        ability: "int",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 10 ft., one target. {@h}7 ({@damage 1d10 + 2}) piercing damage plus 2 ({@damage 1d4}) radiant damage.",
        ],
      },
      {
        name: "Scintillating Breath {@recharge 5}",
        entries: [
          "The dragon exhales a burst of brilliant radiance in a 15-foot cone. Each creature in that area must make a {@dc 12} Constitution saving throw, taking 18 ({@damage 4d8}) radiant damage on a failed save, or half as much damage on a successful one. The dragon then gains 5 temporary hit points by absorbing a portion of the radiant energy.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 10} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "wyrmling",
    senseTags: ["B", "D"],
    actionTags: ["Breath Weapon"],
    languageTags: ["DR", "TP"],
    damageTags: ["P", "R"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Crystal Greatwyrm",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 201,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 21,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 507,
      formula: "26d20 + 234",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: {
        number: 120,
        condition: "(hover)",
      },
      swim: 60,
      canHover: true,
    },
    str: 28,
    dex: 14,
    con: 29,
    int: 30,
    wis: 24,
    cha: 25,
    save: {
      dex: "+10",
      con: "+17",
      wis: "+15",
      cha: "+15",
    },
    skill: {
      arcana: "+26",
      history: "+18",
      perception: "+15",
    },
    senses: ["truesight 120 ft."],
    passive: 25,
    immune: ["radiant"],
    conditionImmune: ["charmed", "frightened", "poisoned", "prone"],
    languages: ["Common", "Draconic"],
    cr: "26",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The greatwyrm casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 26}, {@hit 18} to hit with spell attack):",
        ],
        daily: {
          "1e": [
            "{@spell dispel magic}",
            "{@spell forcecage}",
            "{@spell plane shift}",
            "{@spell reverse gravity}",
            "{@spell time stop}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Gem Awakening (Recharges after a Short or Long Rest)",
        entries: [
          "If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 400 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use its Mass Telekinesis action during the next hour. Award a party an additional 90,000 XP (180,000 XP total) for defeating the greatwyrm after its Gem Awakening activates.",
        ],
      },
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 17} to hit, reach 15 ft., one target. {@h}20 ({@damage 2d10 + 9}) piercing damage plus 16 ({@damage 3d10}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 17} to hit, reach 10 ft., one target. {@h}18 ({@damage 2d8 + 9}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 19}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} in this way at a time.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm exhales crushing force in a 300-foot cone. Each creature in that area must make a {@dc 25} Dexterity saving throw. On a failed save, the creature takes 71 ({@damage 11d12}) force damage and is knocked {@condition prone}. On a successful save, it takes half as much damage and isn't knocked {@condition prone}. On a success or failure, the creature's speed becomes 0 until the end of its next turn.",
        ],
      },
      {
        name: "Mass Telekinesis (Gem Awakening Only; Recharges after a Short or Long Rest)",
        entries: [
          "The greatwyrm targets any number of creatures and objects it can see within 120 feet of it. No one target can weigh more than 4,000 pounds, and objects can't be targeted if they're being worn or carried. Each targeted creature must succeed on a {@dc 26} Strength saving throw or be {@condition restrained} in the greatwyrm's telekinetic grip. At the end of a creature's turn, it can repeat the saving throw, ending the effect on itself on a success.",
          "At the end of the greatwyrm's turn, it can move each creature or object it has in its telekinetic grip up to 60 feet in any direction, but not beyond 120 feet of itself. In addition, it can choose any number of creatures {@condition restrained} in this way and deal 45 ({@damage 7d12}) force damage to each of them.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The greatwyrm magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the greatwyrm is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The greatwyrm magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The greatwyrm makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The greatwyrm uses Psychic Step or Spellcasting."],
      },
      {
        name: "Psychic Beam (Costs 3 Actions)",
        entries: [
          "The greatwyrm emits a beam of psychic energy in a 90-foot line that is 10 feet wide. Each creature in that area must make a {@dc 26} Intelligence saving throw, taking 27 ({@damage 5d10}) psychic damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 15} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["O", "P", "S", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Deep Dragon Wyrmling",
    source: "FTD",
    page: 175,
    size: ["M"],
    type: "dragon",
    alignment: ["N", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 27,
      formula: "5d8 + 5",
    },
    speed: {
      walk: 30,
      burrow: 15,
      fly: 60,
      swim: 30,
    },
    str: 14,
    dex: 11,
    con: 12,
    int: 11,
    wis: 12,
    cha: 13,
    save: {
      dex: "+2",
      con: "+3",
      wis: "+3",
      cha: "+3",
    },
    skill: {
      perception: "+3",
      persuasion: "+3",
      stealth: "+4",
    },
    senses: ["blindsight 10 ft.", "darkvision 90 ft."],
    passive: 13,
    resist: ["poison", "psychic"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Draconic"],
    cr: "1",
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d10 + 2}) piercing damage.",
        ],
      },
      {
        name: "Nightmare Breath {@recharge 5}",
        entries: [
          "The dragon exhales a cloud of spores in a 15-foot cone. Each creature in that area must make a {@dc 11} Wisdom saving throw. On a failed save, the creature takes 5 ({@damage 1d10}) psychic damage, and it is {@condition frightened} of the dragon for 1 minute. On a successful save, the creature takes half as much damage with no additional effects. A {@condition frightened} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 9} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "wyrmling",
    senseTags: ["B", "D"],
    actionTags: ["Breath Weapon"],
    languageTags: ["DR"],
    damageTags: ["P", "Y"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["frightened"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dracohydra",
    source: "FTD",
    page: 176,
    size: ["H"],
    type: "monstrosity",
    alignment: ["C", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 218,
      formula: "19d12 + 95",
    },
    speed: {
      walk: 30,
      swim: 30,
      fly: 30,
    },
    str: 20,
    dex: 12,
    con: 20,
    int: 6,
    wis: 12,
    cha: 12,
    skill: {
      perception: "+9",
    },
    senses: ["darkvision 60 ft."],
    passive: 19,
    languages: ["understands Draconic but can't speak"],
    cr: "11",
    trait: [
      {
        name: "Multiple Heads",
        entries: [
          "The dracohydra has five heads. While it has more than one head, the dracohydra has advantage on saving throws against being {@condition blinded}, {@condition charmed}, {@condition deafened}, {@condition frightened}, {@condition stunned}, and knocked {@condition unconscious}.",
          "Whenever the dracohydra takes 30 or more damage in a single turn, one of its heads dies. If all its heads die, the dracohydra dies.",
          "At the end of its turn, the dracohydra grows two heads for each of its heads that died since its last turn, unless it has taken radiant damage since its last turn. The dracohydra regains 10 hit points for each head regrown this way.",
        ],
      },
      {
        name: "Reactive Heads",
        entries: [
          "For each head the dracohydra has beyond one, it gets an extra reaction that can be used only for opportunity attacks.",
        ],
      },
      {
        name: "Wakeful",
        entries: [
          "While the dracohydra sleeps, at least one of its heads is awake.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dracohydra makes as many Bite attacks as it has heads."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 10 ft., one target. {@h}10 ({@damage 1d10 + 5}) damage of a type chosen by the dracohydra: acid, cold, fire, lightning, or poison.",
        ],
      },
      {
        name: "Prismatic Breath {@recharge 4}",
        entries: [
          "The dracohydra's heads exhale a single breath of multicolored energy in a 60-foot cone. Each creature in that area must make a {@dc 17} Dexterity saving throw. On a failed save, the creature takes 33 ({@damage 6d10}) damage of a type chosen by the dracohydra: acid, cold, fire, lightning, or poison. On a successful save, the creature takes half as much damage.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["CS", "DR"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Draconian Dreadnought",
    source: "FTD",
    page: 177,
    size: ["L"],
    type: "monstrosity",
    alignment: ["A"],
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 57,
      formula: "6d10 + 24",
    },
    speed: {
      walk: 30,
      fly: 60,
    },
    str: 18,
    dex: 10,
    con: 18,
    int: 10,
    wis: 10,
    cha: 10,
    save: {
      str: "+6",
      wis: "+2",
    },
    senses: ["darkvision 60 ft."],
    passive: 10,
    languages: ["Common", "Draconic"],
    cr: "4",
    trait: [
      {
        name: "Death Throes",
        entries: [
          "When the draconian is reduced to 0 hit points, it bursts into flames and is reduced to ashes. Each creature in a 10-foot-radius sphere centered on the draconian must succeed on a {@dc 13} Dexterity saving throw or take 10 ({@damage 3d6}) fire damage.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The draconian makes two Serrated Sword attacks and one Tail attack.",
        ],
      },
      {
        name: "Serrated Sword",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}13 ({@damage 2d8 + 4}) slashing damage.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d8 + 4}) bludgeoning damage. If the target is a Large or smaller creature, it must succeed on a {@dc 14} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
    ],
    reaction: [
      {
        name: "Shape Theft",
        entries: [
          "After the draconian kills a Medium or smaller Humanoid, the draconian can magically transform itself to look and feel like that creature while retaining its game statistics (other than its size). This transformation lasts until the draconian dies or uses an action to end it.",
        ],
      },
    ],
    traitTags: ["Death Burst"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "F", "S"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Draconian Foot Soldier",
    source: "FTD",
    page: 178,
    size: ["M"],
    type: "monstrosity",
    alignment: ["A"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 22,
      formula: "4d8 + 4",
    },
    speed: {
      walk: 30,
    },
    str: 13,
    dex: 11,
    con: 13,
    int: 8,
    wis: 8,
    cha: 10,
    senses: ["darkvision 60 ft."],
    passive: 9,
    languages: ["Common", "Draconic"],
    cr: "1/2",
    trait: [
      {
        name: "Controlled Fall",
        entries: [
          "When the draconian falls and isn't {@condition incapacitated}, it subtracts up to 100 feet from the fall when calculating the fall's damage.",
        ],
      },
      {
        name: "Death Throes",
        entries: [
          "When the draconian is reduced to 0 hit points, its body turns to stone and releases a petrifying gas. Each creature within 5 feet of the draconian must succeed on a {@dc 11} Constitution saving throw or be {@condition restrained} as it begins to turn to stone. The {@condition restrained} creature must repeat the saving throw at the end of its next turn. On a success, the effect ends; otherwise the creature is {@condition petrified} for 1 minute. After 1 minute, the body of the draconian crumbles to dust.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The draconian makes two Shortsword attacks."],
      },
      {
        name: "Shortsword",
        entries: [
          "{@atk mw} {@hit 3} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d6 + 1}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["shortsword|phb"],
    traitTags: ["Death Burst"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["P"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["petrified", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Draconian Infiltrator",
    source: "FTD",
    page: 178,
    size: ["M"],
    type: "monstrosity",
    alignment: ["A"],
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 39,
      formula: "6d8 + 12",
    },
    speed: {
      walk: 40,
      climb: 30,
    },
    str: 11,
    dex: 17,
    con: 14,
    int: 9,
    wis: 13,
    cha: 11,
    save: {
      dex: "+5",
    },
    skill: {
      perception: "+3",
      stealth: "+7",
    },
    senses: ["darkvision 60 ft."],
    passive: 13,
    immune: ["poison"],
    conditionImmune: ["poisoned"],
    languages: ["Common", "Draconic"],
    cr: "3",
    trait: [
      {
        name: "Death Throes",
        entries: [
          "When the draconian is reduced to 0 hit points, it turns into a puddle of acid and splashes acid on those around it. Each creature within 5 feet of the draconian must succeed on a {@dc 12} Dexterity saving throw or be covered in acid for 1 minute. A creature can use its action to scrape or wash the acid off itself or another creature. A creature covered in the acid takes 7 ({@damage 2d6}) acid damage at the start of each of its turns.",
        ],
      },
      {
        name: "Glide",
        entries: [
          "When the draconian falls and isn't {@condition incapacitated}, it subtracts up to 100 feet from the fall when calculating the fall's damage, and it can move up to 2 feet horizontally for every 1 foot it descends.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The draconian makes two Dagger attacks. If both attacks hit the same creature, the target must succeed on a {@dc 12} Constitution saving throw or become {@condition poisoned} until the end of the target's next turn. While {@condition poisoned} in this way, the target is also {@condition paralyzed}.",
        ],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 5} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}5 ({@damage 1d4 + 3}) piercing damage plus 7 ({@damage 2d6}) poison damage.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    traitTags: ["Death Burst"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["A", "I", "P"],
    miscTags: ["AOE", "MW", "RW", "THW"],
    conditionInflict: ["paralyzed", "poisoned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Draconian Mage",
    source: "FTD",
    page: 179,
    size: ["M"],
    type: "monstrosity",
    alignment: ["A"],
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 40,
      formula: "9d8",
    },
    speed: {
      walk: 30,
    },
    str: 14,
    dex: 10,
    con: 11,
    int: 11,
    wis: 10,
    cha: 14,
    save: {
      int: "+2",
      wis: "+2",
      cha: "+4",
    },
    senses: ["darkvision 60 ft."],
    passive: 10,
    languages: ["Common", "Draconic"],
    cr: "2",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The draconian casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 12}):",
        ],
        daily: {
          "1e": [
            "{@spell enlarge/reduce}",
            "{@spell invisibility}",
            "{@spell stinking cloud}",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Death Throes",
        entries: [
          "When the draconian is reduced to 0 hit points, its scales and flesh immediately shrivel away and its bones explode. Each creature within 10 feet of it must succeed on a {@dc 10} Dexterity saving throw or take 9 ({@damage 2d8}) force damage.",
        ],
      },
      {
        name: "Glide",
        entries: [
          "When the draconian falls and isn't {@condition incapacitated}, it subtracts up to 100 feet from the fall when calculating the fall's damage, and it can move up to 2 feet horizontally for every 1 foot it descends.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The draconian makes two Trident or Necrotic Ray attacks."],
      },
      {
        name: "Trident",
        entries: [
          "{@atk mw,rw} {@hit 4} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}5 ({@damage 1d6 + 2}) piercing damage, or 6 ({@damage 1d8 + 2}) piercing damage if used with two hands to make a melee attack.",
        ],
      },
      {
        name: "Necrotic Ray",
        entries: [
          "{@atk rs} {@hit 4} to hit, range 60 ft., one target. {@h}10 ({@damage 3d6}) necrotic damage.",
        ],
      },
    ],
    attachedItems: ["trident|phb"],
    traitTags: ["Death Burst"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["N", "O", "P"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW", "RW", "THW"],
    conditionInflictSpell: ["invisible"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Draconian Mastermind",
    source: "FTD",
    page: 180,
    size: ["M"],
    type: "monstrosity",
    alignment: ["A"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 67,
      formula: "9d8 + 27",
    },
    speed: {
      walk: 35,
    },
    str: 13,
    dex: 14,
    con: 16,
    int: 15,
    wis: 11,
    cha: 17,
    save: {
      int: "+5",
      wis: "+3",
      cha: "+6",
    },
    skill: {
      perception: "+3",
    },
    senses: ["truesight 60 ft."],
    passive: 13,
    conditionImmune: ["charmed"],
    languages: ["Common", "Draconic"],
    cr: "6",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The draconian casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 14}):",
        ],
        will: ["{@spell invisibility}", "{@spell mage hand}"],
        daily: {
          "2e": [
            "{@spell dimension door}",
            "{@spell disguise self}",
            "{@spell sending}",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Death Throes",
        entries: [
          "When the draconian is reduced to 0 hit points, its magical essence lashes out as a ball of lightning at the closest creature within 30 feet of it before arcing out to up to two other creatures within 15 feet of the first. Each creature must make a {@dc 14} Dexterity saving throw. On a failed save, the creature takes 9 ({@damage 2d8}) lightning damage and is {@condition stunned} until the end of its next turn. On a successful save, the creature takes half as much damage and isn't {@condition stunned}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The draconian makes three Rend or Energy Ray attacks."],
      },
      {
        name: "Rend",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}5 ({@damage 1d6 + 2}) slashing damage.",
        ],
      },
      {
        name: "Energy Ray",
        entries: [
          "{@atk rs} {@hit 6} to hit, range 60 ft., one target. {@h}8 ({@damage 1d10 + 3}) force damage.",
        ],
      },
      {
        name: "Noxious Breath {@recharge 5}",
        entries: [
          "The draconian exhales a 15-foot cone of noxious gas. Each creature in that area must make a {@dc 14} Constitution saving throw. On a failed save, the creature takes 21 ({@damage 6d6}) poison damage and gains 1 level of {@condition exhaustion}. On a successful save, the creature takes half as much damage, doesn't gain {@condition exhaustion}, and is immune to all draconians' Noxious Breath for 24 hours.",
        ],
      },
    ],
    reaction: [
      {
        name: "Magic Shield (3/Day)",
        entries: [
          "When the draconian is hit by an attack roll, it can create an {@condition invisible} barrier of magical force around itself, granting it a +5 bonus to its AC against that attack and potentially causing the attack to miss.",
        ],
      },
    ],
    traitTags: ["Death Burst"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["I", "L", "O", "S"],
    damageTagsSpell: ["O"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["exhaustion", "stunned"],
    conditionInflictSpell: ["invisible"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Draconic Shard",
    source: "FTD",
    page: 181,
    size: ["H"],
    type: "undead",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["deflection"],
      },
    ],
    hp: {
      average: 168,
      formula: "16d12 + 64",
    },
    speed: {
      walk: 0,
      fly: {
        number: 80,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 1,
    dex: 12,
    con: 18,
    int: 22,
    wis: 18,
    cha: 22,
    save: {
      dex: "+7",
      int: "+12",
      wis: "+10",
      cha: "+12",
    },
    skill: {
      arcana: "+12",
      history: "+12",
      perception: "+16",
      stealth: "+7",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 26,
    resist: [
      "acid",
      "fire",
      {
        resist: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    immune: ["cold", "necrotic", "poison", "psychic"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "grappled",
      "paralyzed",
      "petrified",
      "poisoned",
      "prone",
    ],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: "17",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The shard casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 20}):",
        ],
        will: [
          "{@spell detect thoughts}",
          "{@spell invisibility}",
          "{@spell telekinesis}",
        ],
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Deflection",
        entries: ["The shard's AC includes its Intelligence modifier."],
      },
      {
        name: "Incorporeal Movement",
        entries: [
          "The shard can move through creatures and objects as if they were {@quickref difficult terrain||3}. If it ends its turn inside an object, it takes 5 ({@damage 1d10}) force damage.",
        ],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the shard fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Rejuvenation",
        entries: [
          "When it drops to 0 hit points, the shard disappears and leaves a Tiny cracked gemstone in its space. The gemstone matches the kind of gem dragon it was in life and has AC 20, 15 hit points, and immunity to all damage except force. Unless the gemstone is destroyed, after {@dice 1d20} days, the gemstone dissipates and the shard re-forms, regaining all its hit points and appearing in the place the gemstone once occupied or in the nearest unoccupied space.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The shard doesn't require air, food, drink, or sleep."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The shard makes two Telekinetic Rend attacks."],
      },
      {
        name: "Telekinetic Rend",
        entries: [
          "{@atk ms,rs} {@hit 12} to hit, reach 10 ft. or range 120 ft., one target. {@h}15 ({@damage 2d8 + 6}) force damage.",
        ],
      },
      {
        name: "Inhabit Object",
        entries: [
          "The shard disappears as it pours its psychic essence into a Medium or smaller nonsentient object it can see within 30 feet of it, magically possessing it. The object uses the shard's AC, and any damage dealt to the object applies to the shard's hit points. The shard inhabits the object until it uses an action to leave; until it is turned; until it is reduced to 0 hit points; or until an effect that ends possession, such as a {@spell dispel evil and good} spell, is used on it. When it leaves the object, it reappears in the nearest unoccupied space.",
          "While inhabited, the object becomes a magic item if it wasn't already, and a Tiny cracked gemstone matching the kind of gem dragon the shard was in life appears somewhere on the object. The shard can cause the object to fly using the shard's own flying speed, use its senses, speak verbally or telepathically, cast spells, and use its legendary actions.",
          "If a creature wears or carries the inhabited object, the shard can grant the creature the following benefits:",
          "Each of the creature's attacks deals an extra {@damage 1d8} force damage on a hit.",
          "The creature gains resistance to psychic damage.",
        ],
      },
      {
        name: "Psychic Crush {@recharge 5}",
        entries: [
          "The shard unleashes a pulse of psychic power. Each creature of the shard's choice in a 60-foot-radius sphere centered on it must make a {@dc 20} Intelligence saving throw. On a failed save, the creature takes 55 ({@damage 10d10}) psychic damage and is {@condition stunned} until the end of its next turn. On a successful save, the creature takes half as much damage and isn't {@condition stunned}.",
        ],
      },
    ],
    legendary: [
      {
        name: "Rend",
        entries: ["The shard makes one Telekinetic Rend attack."],
      },
      {
        name: "Cast a Spell (Costs 2 Actions)",
        entries: ["The shard uses Spellcasting."],
      },
      {
        name: "Commanding Thought (Costs 2 Actions)",
        entries: [
          "The shard targets a creature it can see within 30 feet of it. The target must succeed on a {@dc 20} Wisdom saving throw or be {@condition charmed} until the end of its next turn. While {@condition charmed} in this way, the target becomes the shard's puppet, acting and moving in accordance with its telepathic commands. While under the shard's control, the target can take only the Attack (shard chooses the target) or Dash action on its turn.",
        ],
      },
    ],
    traitTags: [
      "Incorporeal Movement",
      "Legendary Resistances",
      "Rejuvenation",
      "Unusual Nature",
    ],
    senseTags: ["B", "SD"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["O", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "RCH"],
    conditionInflict: ["charmed", "stunned"],
    conditionInflictSpell: ["invisible", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Draconic Spirit",
    source: "FTD",
    page: 21,
    summonedBySpell: "Summon Draconic Spirit|FTD",
    summonedBySpellLevel: 5,
    size: ["L"],
    type: "dragon",
    alignment: [
      {
        alignment: ["N"],
      },
    ],
    ac: [
      {
        special: "14 + the level of the spell (natural armor)",
      },
    ],
    hp: {
      special:
        "50 + 10 for each spell level above 5th (the dragon has a number of Hit Dice [d10s] equal to the level of the spell)",
    },
    speed: {
      walk: 30,
      fly: 60,
      swim: 30,
    },
    str: 19,
    dex: 14,
    con: 17,
    int: 10,
    wis: 14,
    cha: 14,
    senses: ["blindsight 30 ft.", "darkvision 60 ft."],
    passive: 12,
    resist: [
      {
        resist: ["acid", "cold", "fire", "lightning", "poison"],
        cond: true,
        note: "(Chromatic and Metallic Only)",
      },
      {
        resist: ["force", "necrotic", "psychic", "radiant", "thunder"],
        cond: true,
        note: "(Gem Only)",
      },
    ],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Draconic", "understands the languages you speak"],
    pbNote: "equals your bonus",
    trait: [
      {
        name: "Shared Resistances",
        entries: [
          "When you summon the dragon, choose one of its damage resistances. You have resistance to the chosen damage type until the spell ends.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The dragon makes a number of Rend attacks equal to half the spell's level (rounded down), and it uses Breath Weapon.",
        ],
      },
      {
        name: "Rend",
        entries: [
          "{@atk mw} your spell attack modifier to hit, reach 10 ft., one target. {@h}{@damage 1d6 + 4 + summonSpellLevel} piercing damage.",
        ],
      },
      {
        name: "Breath Weapon",
        entries: [
          "The dragon exhales destructive energy in a 30-foot cone. Each creature in that area must make a Dexterity saving throw against your spell save DC. A creature takes {@damage 2d6} damage of a type this dragon has resistance to (your choice) on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    senseTags: ["B", "D"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["DR"],
    damageTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
  },
  {
    name: "Dragon Blessed",
    source: "FTD",
    page: 188,
    size: ["M"],
    type: "humanoid",
    alignment: ["A"],
    ac: [
      {
        ac: 14,
        from: ["{@item scale mail|PHB}"],
      },
    ],
    hp: {
      average: 75,
      formula: "10d8 + 30",
    },
    speed: {
      walk: 30,
    },
    str: 12,
    dex: 10,
    con: 16,
    int: 14,
    wis: 17,
    cha: 10,
    save: {
      con: "+6",
      wis: "+6",
    },
    skill: {
      medicine: "+6",
      religion: "+5",
    },
    passive: 13,
    conditionImmune: ["frightened"],
    languages: ["Common", "Draconic", "and any two languages"],
    cr: "5",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The blessed casts one of the following spells, using Wisdom as the spellcasting ability (spell save {@dc 14}):",
        ],
        will: ["{@spell light}", "{@spell thaumaturgy}"],
        daily: {
          "1e": [
            "{@spell enhance ability}",
            "{@spell flame strike}",
            "{@spell mass cure wounds}",
            "{@spell revivify}",
            "{@spell tongues}",
          ],
        },
        ability: "wis",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The blessed makes two Mace or Radiant Bolt attacks."],
      },
      {
        name: "Mace",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d6 + 1}) bludgeoning damage plus 18 ({@damage 4d8}) radiant damage.",
        ],
      },
      {
        name: "Radiant Bolt",
        entries: [
          "{@atk rs} {@hit 6} to hit, range 120 ft., one target. {@h}22 ({@damage 5d8}) radiant damage, and the blessed regains 5 ({@dice 1d10}) hit points.",
        ],
      },
    ],
    attachedItems: ["mace|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR", "X"],
    damageTags: ["B", "R"],
    damageTagsSpell: ["F", "R"],
    spellcastingTags: ["O"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragon Chosen",
    source: "FTD",
    page: 189,
    size: ["M"],
    type: "humanoid",
    alignment: ["A"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 45,
      formula: "7d8 + 14",
    },
    speed: {
      walk: 30,
    },
    str: 18,
    dex: 18,
    con: 14,
    int: 10,
    wis: 13,
    cha: 14,
    save: {
      str: "+6",
      dex: "+6",
      con: "+4",
    },
    skill: {
      athletics: "+6",
      perception: "+3",
    },
    passive: 13,
    conditionImmune: ["frightened"],
    languages: ["Common", "Draconic"],
    cr: "3",
    action: [
      {
        name: "Multiattack",
        entries: [
          "The chosen makes one Handaxe attack and two Shortsword attacks.",
        ],
      },
      {
        name: "Handaxe",
        entries: [
          "{@atk mw,rw} {@hit 6} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}7 ({@damage 1d6 + 4}) slashing damage. Hit or Miss: The handaxe magically returns to the chosen's hand immediately after a ranged attack.",
        ],
      },
      {
        name: "Shortsword",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d6 + 4}) piercing damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Biting Rebuke",
        entries: [
          "Immediately after the chosen takes damage from a creature within 5 feet of it, it can make a Shortsword attack with advantage against that creature.",
        ],
      },
    ],
    attachedItems: ["handaxe|phb", "shortsword|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["P", "S"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragon Speaker",
    source: "FTD",
    page: 189,
    size: ["S"],
    type: "humanoid",
    alignment: ["A"],
    ac: [
      {
        ac: 13,
        from: ["{@item leather armor|PHB}"],
      },
    ],
    hp: {
      average: 36,
      formula: "8d6 + 8",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 14,
    con: 12,
    int: 13,
    wis: 11,
    cha: 17,
    save: {
      dex: "+4",
      cha: "+5",
    },
    skill: {
      persuasion: "+5",
      religion: "+3",
    },
    senses: ["darkvision 60 ft."],
    passive: 10,
    conditionImmune: ["charmed", "frightened"],
    languages: ["Common", "Draconic", "and any two languages"],
    cr: "2",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The speaker casts one of the following spells, using Charisma as the spellcasting ability (spell save {@dc 13}):",
        ],
        will: ["{@spell dancing lights}"],
        daily: {
          "1e": [
            "{@spell calm emotions}",
            "{@spell charm person}",
            "{@spell command}",
            "{@spell comprehend languages}",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The speaker makes two Thunder Bolt attacks."],
      },
      {
        name: "Thunder Bolt",
        entries: [
          "{@atk ms,rs} {@hit 5} to hit, reach 5 ft. or range 60 ft., one target. {@h}13 ({@damage 3d8}) thunder damage, and the target is pushed horizontally up to 10 feet away from the speaker.",
        ],
      },
    ],
    reaction: [
      {
        name: "Disarming Words (3/Day)",
        entries: [
          "When a creature the speaker can see within 60 feet of it makes a damage roll, the speaker can roll a {@dice d6} and subtract the number rolled from that damage roll.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR", "X"],
    damageTags: ["T"],
    spellcastingTags: ["O"],
    conditionInflictSpell: ["charmed", "prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragon Turtle Wyrmling",
    source: "FTD",
    page: 192,
    size: ["L"],
    type: "dragon",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 18,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 90,
      formula: "12d10 + 24",
    },
    speed: {
      walk: 20,
      swim: 30,
    },
    str: 17,
    dex: 10,
    con: 15,
    int: 8,
    wis: 10,
    cha: 10,
    save: {
      dex: "+2",
      con: "+4",
      wis: "+2",
    },
    senses: ["darkvision 120 ft."],
    passive: 10,
    resist: ["fire"],
    languages: ["Draconic"],
    cr: "4",
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon turtle can breathe air and water."],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 10 ft., one target. {@h}11 ({@damage 1d12 + 3}) piercing damage.",
        ],
      },
      {
        name: "Steam Breath {@recharge 5}",
        entries: [
          "The dragon turtle exhales steam in a 15-foot cone. Each creature in that area must make a {@dc 12} Constitution saving throw, taking 17 ({@damage 5d6}) fire damage on a failed save, or half as much damage on a successful one. Being underwater doesn't grant resistance against this damage.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 8} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "wyrmling",
    traitTags: ["Amphibious"],
    senseTags: ["SD"],
    actionTags: ["Breath Weapon"],
    languageTags: ["DR"],
    damageTags: ["F", "P"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Dragonblood Ooze",
    source: "FTD",
    page: 182,
    size: ["L"],
    type: "ooze",
    alignment: ["U"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 68,
      formula: "8d10 + 24",
    },
    speed: {
      walk: 20,
      climb: 20,
    },
    str: 18,
    dex: 6,
    con: 17,
    int: 2,
    wis: 12,
    cha: 10,
    skill: {
      perception: "+4",
      stealth: "+4",
    },
    senses: ["blindsight 120 ft. (blind beyond this radius)"],
    passive: 14,
    resist: ["acid", "cold", "fire", "lightning", "poison"],
    conditionImmune: [
      "blinded",
      "charmed",
      "deafened",
      "exhaustion",
      "frightened",
      "grappled",
      "prone",
      "restrained",
    ],
    languages: [
      "understands Draconic and the languages of its creator but can't speak",
    ],
    cr: "5",
    trait: [
      {
        name: "Amorphous",
        entries: [
          "The ooze can move through a space as narrow as 1 inch wide without squeezing.",
        ],
      },
      {
        name: "Spider Climb",
        entries: [
          "The ooze can climb difficult surfaces, including upside down on ceilings, without needing to make an ability check.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The ooze makes two Pseudopod attacks. The ooze can replace one Pseudopod attack with its Slime Breath, if available.",
        ],
      },
      {
        name: "Pseudopod",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 10 ft., one target. {@h}9 ({@damage 1d10 + 4}) bludgeoning damage plus 14 ({@damage 4d6}) acid damage. If the target is a Large or smaller creature, it is {@condition grappled} (escape {@dc 15}). Until this grapple ends, the target takes 7 ({@damage 2d6}) acid damage at the start of each of its turns.",
        ],
      },
      {
        name: "Slime Breath {@recharge}",
        entries: [
          "The ooze expels a spray of its gelatinous mass in a 30-foot cone. Each creature in that area must make a {@dc 14} Dexterity saving throw. On a failed save, the creature takes 22 ({@damage 4d10}) acid damage and is pulled up to 30 feet straight toward the ooze. On a successful save, the creature takes half as much damage and isn't pulled.",
        ],
      },
    ],
    traitTags: ["Amorphous", "Spider Climb"],
    senseTags: ["B"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["CS"],
    damageTags: ["A", "B"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragonbone Golem",
    source: "FTD",
    page: 183,
    size: ["L"],
    type: "construct",
    alignment: ["U"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 161,
      formula: "19d10 + 57",
    },
    speed: {
      walk: 40,
    },
    str: 20,
    dex: 10,
    con: 17,
    int: 3,
    wis: 11,
    cha: 10,
    senses: ["darkvision 60 ft."],
    passive: 10,
    immune: ["poison"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: [
      "understands Draconic and the languages of its creator but can't speak",
    ],
    cr: "11",
    trait: [
      {
        name: "Fear Aura",
        entries: [
          "Each creature of the golem's choice that starts its turn within 20 feet of the golem must make a {@dc 15} Wisdom saving throw unless the golem is {@condition incapacitated}. On a failed save, the creature is {@condition frightened} until the start of its next turn. On a successful save, the creature is immune to this golem's Fear Aura for the next 24 hours.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "The golem has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The golem doesn't require air, food, drink, or sleep."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The golem makes one Pinion attack and two Rend attacks."],
      },
      {
        name: "Pinion",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}12 ({@damage 2d6 + 5}) piercing damage. If the target is a Medium or smaller creature, it is pinned beneath the bony pinion and {@condition restrained}. The golem has two pinions, each of which can restrain one target. If a creature is {@condition restrained} by one of the pinions, the golem can't attack with it. Any creature {@condition restrained} by a pinion can free itself at the start of its turn with a successful {@dc 17} Strength (Athletics) check.",
        ],
      },
      {
        name: "Rend",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}12 ({@damage 2d6 + 5}) piercing damage plus 5 ({@damage 1d10}) necrotic damage.",
        ],
      },
      {
        name: "Petrifying Breath {@recharge 5}",
        entries: [
          "The golem emits a 60-foot cone of petrifying gas from its mouth. Each creature in that area must succeed on a {@dc 15} Constitution saving throw or take 35 ({@damage 10d6}) poison damage and be {@condition restrained} as it begins to turn to stone. The {@condition restrained} target must repeat the saving throw at the end of its next turn. On a successful save, the effect ends on the target. On a failed save, the target is {@condition petrified}.",
        ],
      },
    ],
    traitTags: ["Magic Resistance", "Unusual Nature"],
    senseTags: ["D"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["CS"],
    damageTags: ["I", "N", "P"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["frightened", "petrified", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragonborn of Bahamut",
    source: "FTD",
    page: 184,
    size: ["M"],
    type: "humanoid",
    alignment: ["L", "G"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 18,
        from: ["{@item half plate armor|PHB|half plate}", "{@item shield|PHB}"],
      },
    ],
    hp: {
      average: 93,
      formula: "11d8 + 44",
    },
    speed: {
      walk: 30,
      fly: 30,
    },
    str: 19,
    dex: 13,
    con: 18,
    int: 12,
    wis: 14,
    cha: 17,
    save: {
      con: "+7",
      int: "+4",
      wis: "+5",
      cha: "+6",
    },
    skill: {
      athletics: "+7",
      perception: "+5",
      persuasion: "+6",
    },
    passive: 15,
    conditionImmune: ["frightened"],
    languages: ["Common", "Draconic"],
    cr: "8",
    trait: [
      {
        name: "Legendary Resistance (1/Day)",
        entries: [
          "If the dragonborn fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragonborn makes three Longsword attacks."],
      },
      {
        name: "Longsword",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d8 + 4}) slashing damage, or 9 ({@damage 1d10 + 4}) slashing damage if used with two hands, plus 13 ({@damage 3d8}) radiant damage. The dragonborn can cause the sword to flare with bright light, and the target must succeed on a {@dc 14} Constitution saving throw or be {@condition blinded} until the start of the dragonborn's next turn. The sword can flare in this way only once per turn.",
        ],
      },
      {
        name: "Healing Touch (1/Day)",
        entries: [
          "The dragonborn touches another creature within 5 feet of it. The target magically regains 40 hit points. In addition, all diseases and poisons affecting the target are removed.",
        ],
      },
      {
        name: "Radiant Breath {@recharge}",
        entries: [
          "The dragonborn exhales fiery radiance in a 30-foot cone. Each creature in that area must make a {@dc 15} Dexterity saving throw, taking 44 ({@damage 8d10}) radiant damage on a failed save, or half as much damage on a successful one. When the dragonborn uses this action, it can choose up to three creatures in the cone. These creatures take no damage from the radiance and instead regain 22 ({@dice 4d10}) hit points each.",
        ],
      },
    ],
    attachedItems: ["longsword|phb"],
    traitTags: ["Legendary Resistances"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["R", "S"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["blinded"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragonborn of Sardior",
    source: "FTD",
    page: 185,
    size: ["M"],
    type: "humanoid",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["mental defense"],
      },
    ],
    hp: {
      average: 75,
      formula: "10d8 + 30",
    },
    speed: {
      walk: 30,
      fly: {
        number: 30,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 14,
    dex: 16,
    con: 17,
    int: 18,
    wis: 14,
    cha: 12,
    save: {
      con: "+6",
      int: "+7",
      wis: "+5",
      cha: "+4",
    },
    skill: {
      arcana: "+7",
      history: "+7",
      perception: "+5",
    },
    passive: 15,
    resist: ["psychic"],
    conditionImmune: ["frightened"],
    languages: ["Common", "Draconic"],
    cr: "6",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragonborn casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 15}, {@hit 7} to hit with spell attacks):",
        ],
        daily: {
          "1e": [
            "{@spell Bigby's hand}",
            "{@spell hypnotic pattern}",
            "{@spell telekinesis}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (1/Day)",
        entries: [
          "If the dragonborn fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Mental Defense",
        entries: [
          "While the dragonborn is wearing no armor, its AC includes its Intelligence modifier.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragonborn makes three Mind Blade attacks."],
      },
      {
        name: "Mind Blade",
        entries: [
          "{@atk mw,rw} {@hit 7} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}6 ({@damage 1d4 + 4}) piercing damage plus 10 ({@damage 3d6}) psychic damage.",
        ],
      },
      {
        name: "Heat Breath {@recharge}",
        entries: [
          "The dragonborn exhales a wave of intense heat in a 30-foot cone. Each creature in that area must make a {@dc 14} Constitution saving throw, taking 27 ({@damage 6d8}) fire damage on a failed save, or half as much damage on a successful one. Metal objects in that area glow red-hot until the end of the dragonborn's next turn. Any creature in physical contact with a heated object at the start of its turn must make a {@dc 14} Constitution saving throw. On a failed save, the creature takes 9 ({@damage 2d8}) fire damage and has disadvantage on attack rolls until the start of its next turn.",
        ],
      },
    ],
    traitTags: ["Legendary Resistances"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["F", "P", "Y"],
    damageTagsSpell: ["B", "O"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RW"],
    conditionInflictSpell: ["charmed", "incapacitated", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragonborn of Tiamat",
    source: "FTD",
    page: 185,
    size: ["M"],
    type: "humanoid",
    alignment: ["C", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 18,
        from: ["{@item plate armor|PHB|plate}"],
      },
    ],
    hp: {
      average: 85,
      formula: "10d8 + 40",
    },
    speed: {
      walk: 30,
    },
    str: 20,
    dex: 11,
    con: 18,
    int: 10,
    wis: 12,
    cha: 16,
    save: {
      str: "+8",
      con: "+7",
      wis: "+4",
      cha: "+6",
    },
    skill: {
      athletics: "+8",
      intimidation: "+6",
      perception: "+4",
    },
    passive: 14,
    conditionImmune: ["frightened"],
    languages: ["Common", "Draconic"],
    cr: "7",
    trait: [
      {
        name: "Legendary Resistance (1/Day)",
        entries: [
          "If the dragonborn fails a saving throw, it can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragonborn makes two Greataxe attacks."],
      },
      {
        name: "Greataxe",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 5 ft., one target. {@h}11 ({@damage 1d12 + 5}) slashing damage plus 13 ({@damage 3d8}) necrotic damage.",
        ],
      },
      {
        name: "Necrotic Breath {@recharge}",
        entries: [
          "The dragonborn exhales shadowy fire in a 30-foot cone. Each creature in that area must make a {@dc 15} Wisdom saving throw. On a failed save, the creature takes 36 ({@damage 8d8}) necrotic damage and is {@condition frightened} of the dragonborn for 1 minute. On a successful save, the creature takes half as much damage and isn't {@condition frightened}. A {@condition frightened} creature can repeat the saving throw at end of each of its turns, ending the effect on itself on a success.",
        ],
      },
    ],
    attachedItems: ["greataxe|phb"],
    traitTags: ["Legendary Resistances"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["N", "S"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["frightened"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragonflesh Abomination",
    source: "FTD",
    page: 187,
    size: ["H"],
    type: "monstrosity",
    alignment: ["N", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 66,
      formula: "7d12 + 21",
    },
    speed: {
      walk: 30,
      fly: 40,
    },
    str: 18,
    dex: 14,
    con: 17,
    int: 5,
    wis: 12,
    cha: 6,
    save: {
      str: "+7",
      con: "+6",
    },
    passive: 11,
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["understands Common and Draconic but can't speak"],
    cr: "6",
    trait: [
      {
        name: "Cloying Miasma",
        entries: [
          "The abomination is surrounded by a noxious stench. At the start of the abomination's turn, any creature within 5 feet of it must succeed on a {@dc 14} Constitution saving throw or be {@condition poisoned} until the start of the abomination's next turn.",
        ],
      },
      {
        name: "Regeneration",
        entries: [
          "The abomination regains 10 hit points at the start of its turns if it has at least 1 hit point.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The abomination makes three attacks using Claw, Acidic Spit, or a combination of them. It can replace one of the attacks with a Tail attack.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 10 ft., one target. {@h}8 ({@damage 1d8 + 4}) slashing damage plus 5 ({@damage 1d10}) poison damage.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 15 ft., one target. {@h}10 ({@damage 1d12 + 4}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 15} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Acidic Spit",
        entries: [
          "{@atk rw} {@hit 5} to hit, range 60 ft., one target. {@h}10 ({@damage 3d6}) acid damage.",
        ],
      },
      {
        name: "Acid Belch {@recharge 5}",
        entries: [
          "The abomination belches forth a cloud of acidic gas in a 30-foot cone. Each creature in that area must make a {@dc 14} Constitution saving throw, taking 28 ({@damage 8d6}) acid damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    traitTags: ["Regeneration"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "CS", "DR"],
    damageTags: ["A", "B", "I", "S"],
    miscTags: ["AOE", "MW", "RCH", "RW"],
    conditionInflict: ["poisoned", "prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragonflesh Grafter",
    source: "FTD",
    page: 186,
    size: ["L"],
    type: "monstrosity",
    alignment: ["N", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 52,
      formula: "7d10 + 14",
    },
    speed: {
      walk: 30,
    },
    str: 16,
    dex: 11,
    con: 14,
    int: 10,
    wis: 10,
    cha: 6,
    save: {
      str: "+5",
      con: "+4",
    },
    passive: 10,
    languages: ["Common", "Draconic"],
    cr: "3",
    action: [
      {
        name: "Multiattack",
        entries: [
          "The grafter makes one Claw attack and one Greatclub attack.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 10 ft., one target. {@h}7 ({@damage 1d8 + 3}) slashing damage plus 5 ({@damage 1d10}) poison damage.",
        ],
      },
      {
        name: "Greatclub",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 10 ft., one target. {@h}12 ({@damage 2d8 + 3}) bludgeoning damage.",
        ],
      },
      {
        name: "Acid Retch {@recharge 5}",
        entries: [
          "The grafter retches forth a spray of acidic bile in a 30-foot cone. Each creature in that area must make a {@dc 12} Dexterity saving throw, taking 14 ({@damage 4d6}) acid damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    attachedItems: ["greatclub|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["A", "B", "I", "S"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragonnel",
    source: "FTD",
    page: 190,
    size: ["L"],
    type: "dragon",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 13,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 58,
      formula: "9d10 + 9",
    },
    speed: {
      walk: 30,
      fly: 60,
    },
    str: 16,
    dex: 15,
    con: 12,
    int: 8,
    wis: 13,
    cha: 10,
    skill: {
      perception: "+3",
    },
    senses: ["blindsight 30 ft.", "darkvision 120 ft."],
    passive: 13,
    languages: ["understands Draconic and Common but can't speak"],
    cr: "2",
    trait: [
      {
        name: "Flyby",
        entries: [
          "The dragonnel doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragonnel makes two Rend attacks."],
      },
      {
        name: "Rend",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}10 ({@damage 2d6 + 3}) slashing damage.",
        ],
      },
    ],
    traitTags: ["Flyby"],
    senseTags: ["B", "SD"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "CS", "DR"],
    damageTags: ["S"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Drake Companion",
    source: "FTD",
    page: 15,
    summonedByClass: "Ranger|PHB",
    size: ["S"],
    type: "dragon",
    ac: [
      {
        special: "14 + PB (natural armor)",
      },
    ],
    hp: {
      special:
        "5 + five times your ranger level (the drake has a number of Hit Dice [d10s] equal to your ranger level)",
    },
    speed: {
      walk: 40,
    },
    str: 16,
    dex: 12,
    con: 15,
    int: 8,
    wis: 14,
    cha: 8,
    save: {
      dex: "+1 + PB",
      wis: "+2 + PB",
    },
    senses: ["darkvision 60 ft."],
    passive: 12,
    immune: [
      {
        special: "determined by the drake's draconic essence trait",
      },
    ],
    languages: ["Draconic"],
    pbNote: "equals your bonus",
    trait: [
      {
        name: "Draconic Essence",
        entries: [
          "When you summon the drake, choose a damage type: acid, cold, fire, lightning, or poison. The chosen type determines the drake's damage immunity and the damage of its Infused Strikes trait.",
        ],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} +3 plus PB to hit, reach 5 ft., one target. {@h}{@dice 1d6} plus PB piercing damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Infused Strikes",
        entries: [
          "When another creature within 30 feet of the drake that it can see hits a target with a weapon attack, the drake infuses the strike with its essence, causing the target to take an extra {@damage 1d6} damage of the type determined by its Draconic Essence.",
        ],
      },
    ],
    senseTags: ["D"],
    languageTags: ["DR"],
    miscTags: ["MW"],
    hasToken: true,
  },
  {
    name: "Egg Hunter Adult",
    source: "FTD",
    page: 193,
    size: ["S"],
    type: "monstrosity",
    alignment: ["U"],
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 52,
      formula: "8d6 + 24",
    },
    speed: {
      walk: 40,
      climb: 40,
    },
    str: 14,
    dex: 20,
    con: 16,
    int: 3,
    wis: 13,
    cha: 5,
    save: {
      dex: "+8",
      wis: "+4",
    },
    skill: {
      perception: "+4",
      stealth: "+11",
    },
    senses: ["darkvision 120 ft."],
    passive: 14,
    conditionImmune: ["frightened", "poisoned"],
    cr: "5",
    trait: [
      {
        name: "Amphibious",
        entries: ["The egg hunter can breathe air and water."],
      },
      {
        name: "False Appearance",
        entries: [
          "If the egg hunter is motionless at the start of combat, it has advantage on its initiative roll. Moreover, if a creature hasn't observed the egg hunter move or act, that creature must succeed on a {@dc 18} Intelligence (Investigation) check to discern that the egg hunter is animate. Dragons have disadvantage on this check.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The egg hunter makes two Barbed Proboscis attacks, and it can use Torpor Spores if it's available.",
        ],
      },
      {
        name: "Barbed Proboscis",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d6 + 5}) piercing damage plus 9 ({@damage 2d8}) necrotic damage, and the egg hunter regains hit points equal to the necrotic damage dealt.",
        ],
      },
      {
        name: "Torpor Spores {@recharge 5}",
        entries: [
          "The egg hunter releases a billow of sparkling blue spores. Each creature in a 30-foot-radius sphere centered on the egg hunter must succeed on a {@dc 14} Constitution saving throw or be {@condition poisoned} for 1 minute. While {@condition poisoned} in this way, the creature can take either an action or a bonus action on its turn but not both, and it can't take reactions. A creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. If a creature's saving throw is successful or the effect ends for it, the creature is immune to this egg hunter's Torpor Spores for the next 24 hours.",
        ],
      },
    ],
    reaction: [
      {
        name: "Rapid Adaptation",
        entries: [
          "When the egg hunter takes damage, it gives itself resistance to that damage.",
        ],
      },
    ],
    traitTags: ["Amphibious", "False Appearance"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    damageTags: ["N", "P"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["poisoned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Egg Hunter Hatchling",
    source: "FTD",
    page: 193,
    size: ["T"],
    type: "monstrosity",
    alignment: ["U"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 28,
      formula: "8d4 + 8",
    },
    speed: {
      walk: 30,
      burrow: 10,
      climb: 30,
    },
    str: 8,
    dex: 17,
    con: 13,
    int: 1,
    wis: 10,
    cha: 5,
    save: {
      dex: "+5",
      wis: "+2",
    },
    skill: {
      perception: "+2",
      stealth: "+7",
    },
    senses: ["darkvision 60 ft."],
    passive: 12,
    conditionImmune: ["frightened"],
    cr: "2",
    trait: [
      {
        name: "Amphibious",
        entries: ["The egg hunter can breathe air and water."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The egg hunter makes two Egg Tooth attacks."],
      },
      {
        name: "Egg Tooth",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}10 ({@damage 2d6 + 3}) piercing damage, or 17 ({@damage 4d6 + 3}) piercing damage if the target is an object.",
        ],
      },
    ],
    bonus: [
      {
        name: "Rapid Movement",
        entries: ["The egg hunter takes the Dash or Disengage action."],
      },
    ],
    traitTags: ["Amphibious"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    damageTags: ["P"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Elder Brain Dragon",
    source: "FTD",
    page: 194,
    size: ["G"],
    type: "aberration",
    alignment: ["L", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 350,
      formula: "20d20 + 140",
    },
    speed: {
      walk: 40,
      fly: {
        number: 80,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 27,
    dex: 13,
    con: 25,
    int: 21,
    wis: 19,
    cha: 24,
    save: {
      con: "+14",
      int: "+12",
      wis: "+11",
      cha: "+14",
    },
    skill: {
      arcana: "+12",
      insight: "+18",
      perception: "+18",
    },
    senses: ["blindsight 120 ft."],
    passive: 28,
    immune: ["psychic"],
    conditionImmune: ["charmed", "frightened"],
    languages: ["Deep Speech", "Draconic", "telepathy 5 miles"],
    cr: "22",
    trait: [
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Siege Monster",
        entries: ["The dragon deals double damage to objects and structures."],
      },
      {
        name: "Unusual Nature",
        entries: ["The dragon doesn't require air or sleep."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The dragon makes one Bite attack, two Claw attacks, and one Tentacle attack.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 15} to hit, reach 15 ft., one target. {@h}19 ({@damage 2d10 + 8}) piercing damage plus 11 ({@damage 2d10}) psychic damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 15} to hit, reach 10 ft., one target. {@h}11 ({@damage 1d6 + 8}) slashing damage.",
        ],
      },
      {
        name: "Tentacle",
        entries: [
          "{@atk mw} {@hit 15} to hit, reach 15 ft., one creature. {@h}12 ({@damage 1d8 + 8}) psychic damage. If the target is Huge or smaller, it is {@condition grappled} (escape {@dc 18}). The dragon can have up to four targets {@condition grappled} at a time.",
        ],
      },
      {
        name: "Tadpole Brine Breath {@recharge 5}",
        entries: [
          "The dragon exhales brine in a 120-foot line that is 15 feet wide. Each creature in that area must make a {@dc 22} Constitution saving throw, taking 55 ({@damage 10d10}) psychic damage on a failed save, or half as much damage on a successful one. On a success or failure, if the creature isn't a Construct or an Undead, it becomes infested with illithid tadpoles.",
          "While infested, the creature takes 16 ({@damage 3d10}) psychic damage at the start of each of its turns. The creature can repeat the saving throw at the end of each of its turns, ending the effect on itself after it succeeds on three of these saves. If the creature is targeted by magic that ends a curse or restores 40 hit points or more, the tadpoles infesting the creature are killed instantly, ending the effect on the creature.",
          "If a Humanoid is reduced to 0 hit points while infested, the creature is stable but remains {@condition unconscious} for {@dice 6d12} hours. When the period of unconsciousness ends, the creature transforms into a {@creature mind flayer} (see the Monster Manual) with all its hit points. Casting a {@spell wish} spell on the {@condition unconscious} creature rids it of the infestation and prevents it from turning into a mind flayer.",
        ],
      },
    ],
    legendary: [
      {
        name: "Tentacle",
        entries: ["The dragon makes one Tentacle attack."],
      },
      {
        name: "Shatter Concentration (Costs 2 Actions)",
        entries: [
          "The dragon targets a creature it is grappling. The target's {@status concentration} on a spell it has cast or an ability it is maintaining ends, and the target takes 19 ({@damage 3d12}) psychic damage.",
        ],
      },
    ],
    traitTags: ["Legendary Resistances", "Siege Monster", "Unusual Nature"],
    senseTags: ["B"],
    actionTags: ["Breath Weapon", "Multiattack", "Tentacles"],
    languageTags: ["DR", "DS", "TP"],
    damageTags: ["P", "S", "Y"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Emerald Dragon Wyrmling",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 197,
    size: ["M"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["L", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 39,
      formula: "6d8 + 12",
    },
    speed: {
      walk: 30,
      burrow: 20,
      fly: 60,
    },
    str: 15,
    dex: 12,
    con: 15,
    int: 14,
    wis: 12,
    cha: 14,
    save: {
      dex: "+3",
      con: "+4",
      wis: "+3",
      cha: "+4",
    },
    skill: {
      arcana: "+4",
      deception: "+4",
      perception: "+5",
      stealth: "+3",
    },
    senses: ["blindsight 10 ft.", "darkvision 60 ft."],
    passive: 15,
    resist: ["fire", "psychic"],
    languages: ["Draconic", "telepathy 120 ft."],
    cr: "2",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 12}):",
        ],
        will: [
          "{@spell mage hand} (the hand is invisible)",
          "{@spell minor illusion}",
        ],
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Tunneler",
        entries: [
          "The dragon can burrow through solid rock at half its burrowing speed and can leave a 10-foot-diameter tunnel in its wake.",
        ],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 10 ft., one target. {@h}7 ({@damage 1d10 + 2}) piercing damage plus 3 ({@damage 1d6}) psychic damage.",
        ],
      },
      {
        name: "Disorienting Breath {@recharge 5}",
        entries: [
          "The dragon exhales a wave of psychic dissonance in a 15-foot cone. Each creature in that area must make a {@dc 12} Intelligence saving throw. On a failed save, the creature takes 17 ({@damage 5d6}) psychic damage, and until the end of its next turn, when the creature makes an attack roll or an ability check, it must roll a {@dice d4} and reduce the total by the number rolled. On a successful save, the creature takes half as much damage with no additional effects.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 12} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "wyrmling",
    traitTags: ["Tunneler"],
    senseTags: ["B", "D"],
    actionTags: ["Breath Weapon"],
    languageTags: ["DR", "TP"],
    damageTags: ["P", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Emerald Greatwyrm",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 201,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 21,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 507,
      formula: "26d20 + 234",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: {
        number: 120,
        condition: "(hover)",
      },
      swim: 60,
      canHover: true,
    },
    str: 28,
    dex: 14,
    con: 29,
    int: 30,
    wis: 24,
    cha: 25,
    save: {
      dex: "+10",
      con: "+17",
      wis: "+15",
      cha: "+15",
    },
    skill: {
      arcana: "+26",
      history: "+18",
      perception: "+15",
    },
    senses: ["truesight 120 ft."],
    passive: 25,
    immune: ["psychic"],
    conditionImmune: ["charmed", "frightened", "poisoned", "prone"],
    languages: ["Common", "Draconic"],
    cr: "26",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The greatwyrm casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 26}, {@hit 18} to hit with spell attack):",
        ],
        daily: {
          "1e": [
            "{@spell dispel magic}",
            "{@spell forcecage}",
            "{@spell plane shift}",
            "{@spell reverse gravity}",
            "{@spell time stop}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Gem Awakening (Recharges after a Short or Long Rest)",
        entries: [
          "If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 400 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use its Mass Telekinesis action during the next hour. Award a party an additional 90,000 XP (180,000 XP total) for defeating the greatwyrm after its Gem Awakening activates.",
        ],
      },
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 17} to hit, reach 15 ft., one target. {@h}20 ({@damage 2d10 + 9}) piercing damage plus 16 ({@damage 3d10}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 17} to hit, reach 10 ft., one target. {@h}18 ({@damage 2d8 + 9}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 19}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} in this way at a time.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm exhales crushing force in a 300-foot cone. Each creature in that area must make a {@dc 25} Dexterity saving throw. On a failed save, the creature takes 71 ({@damage 11d12}) force damage and is knocked {@condition prone}. On a successful save, it takes half as much damage and isn't knocked {@condition prone}. On a success or failure, the creature's speed becomes 0 until the end of its next turn.",
        ],
      },
      {
        name: "Mass Telekinesis (Gem Awakening Only; Recharges after a Short or Long Rest)",
        entries: [
          "The greatwyrm targets any number of creatures and objects it can see within 120 feet of it. No one target can weigh more than 4,000 pounds, and objects can't be targeted if they're being worn or carried. Each targeted creature must succeed on a {@dc 26} Strength saving throw or be {@condition restrained} in the greatwyrm's telekinetic grip. At the end of a creature's turn, it can repeat the saving throw, ending the effect on itself on a success.",
          "At the end of the greatwyrm's turn, it can move each creature or object it has in its telekinetic grip up to 60 feet in any direction, but not beyond 120 feet of itself. In addition, it can choose any number of creatures {@condition restrained} in this way and deal 45 ({@damage 7d12}) force damage to each of them.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The greatwyrm magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the greatwyrm is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The greatwyrm magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The greatwyrm makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The greatwyrm uses Psychic Step or Spellcasting."],
      },
      {
        name: "Psychic Beam (Costs 3 Actions)",
        entries: [
          "The greatwyrm emits a beam of psychic energy in a 90-foot line that is 10 feet wide. Each creature in that area must make a {@dc 26} Intelligence saving throw, taking 27 ({@damage 5d10}) psychic damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 15} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["O", "P", "S", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Eyedrake",
    source: "FTD",
    page: 199,
    size: ["L"],
    type: "aberration",
    alignment: ["L", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 119,
      formula: "14d10 + 42",
    },
    speed: {
      walk: 0,
      fly: {
        number: 30,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 16,
    dex: 10,
    con: 16,
    int: 14,
    wis: 14,
    cha: 16,
    save: {
      con: "+6",
      wis: "+5",
    },
    skill: {
      perception: "+8",
      stealth: "+6",
    },
    senses: ["darkvision 120 ft."],
    passive: 18,
    conditionImmune: ["prone"],
    languages: ["Deep Speech", "Draconic"],
    cr: "8",
    trait: [
      {
        name: "Unusual Nature",
        entries: ["The eyedrake doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 10 ft., one target. {@h}13 ({@damage 3d6 + 3}) piercing damage.",
        ],
      },
      {
        name: "Antimagic Breath {@recharge}",
        entries: [
          "The eyedrake emits a magic wave in a 30-foot cone. Each creature in that area must make a {@dc 14} Constitution saving throw, taking 39 ({@damage 6d12}) force damage on a failed save, or half as much damage on a successful one. Every spell of 3rd level or lower ends on creatures and objects of the eyedrake's choice in that area.",
        ],
      },
      {
        name: "Eye Rays",
        entries: [
          "The eyedrake shoots three of the following magical eye rays at random (reroll duplicates), each ray targeting one creature it can see within 60 feet of it:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                name: "1: Freezing Ray",
                entries: [
                  "The target must make a {@dc 14} Constitution saving throw. On a failed save, the target takes 17 ({@damage 5d6}) cold damage, and its speed is halved until the end of its next turn. On a successful save, the target takes half as much damage with no additional effects.",
                ],
                type: "item",
              },
              {
                name: "2: Debilitating Ray",
                entries: [
                  "The target must succeed on a {@dc 14} Constitution saving throw or take 7 ({@damage 2d6}) thunder damage and become {@condition incapacitated} until the end of its next turn.",
                ],
                type: "item",
              },
              {
                name: "3: Repulsion Ray",
                entries: [
                  "The target must succeed on a {@dc 14} Strength saving throw or take 14 ({@damage 4d6}) force damage and be pushed up to 60 feet away from the eyedrake.",
                ],
                type: "item",
              },
              {
                name: "4: Fire Ray",
                entries: [
                  "The target must make a {@dc 14} Dexterity saving throw, taking 21 ({@damage 6d6}) fire damage on a failed save, or half as much damage on a successful one.",
                ],
                type: "item",
              },
              {
                name: "5: Paralyzing Ray",
                entries: [
                  "The target must succeed on a {@dc 14} Constitution saving throw or be {@condition paralyzed} for 1 minute. The target can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
                ],
                type: "item",
              },
              {
                name: "6: Death Ray",
                entries: [
                  "The target must make a {@dc 14} Dexterity saving throw, taking 28 ({@damage 8d6}) necrotic damage on a failed save, or half as much damage on a successful one. The target dies if the ray reduces it to 0 hit points.",
                ],
                type: "item",
              },
            ],
          },
        ],
      },
    ],
    traitTags: ["Unusual Nature"],
    senseTags: ["SD"],
    actionTags: ["Breath Weapon"],
    languageTags: ["DR", "DS"],
    damageTags: ["C", "F", "N", "O", "P", "T"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["incapacitated", "paralyzed"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Gem Stalker",
    source: "FTD",
    page: 202,
    size: ["L"],
    type: "monstrosity",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 67,
      formula: "9d10 + 18",
    },
    speed: {
      walk: 40,
      climb: 40,
    },
    str: 17,
    dex: 15,
    con: 14,
    int: 15,
    wis: 10,
    cha: 6,
    save: {
      dex: "+5",
      int: "+5",
    },
    skill: {
      perception: "+3",
      stealth: "+5",
    },
    senses: ["darkvision 120 ft."],
    passive: 13,
    resist: ["psychic"],
    languages: ["telepathy 60 ft. understands Draconic but can't speak"],
    cr: "5",
    trait: [
      {
        name: "Spider Climb",
        entries: [
          "The gem stalker can climb difficult surfaces, including upside down on ceilings, without needing to make an ability check.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The gem stalker doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The gem stalker makes four Claw attacks."],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}10 ({@damage 2d6 + 3}) slashing damage.",
        ],
      },
    ],
    bonus: [
      {
        name: "Crystal Dart",
        entries: [
          "{@atk rs} {@hit 5} to hit, range 30 ft., one target. {@h}7 ({@damage 1d10 + 2}) force damage, and one of the following effects occurs, determined by the kind of dragon that created the gem stalker:",
        ],
      },
      {
        name: "Amethyst",
        entries: [
          "The gem stalker can teleport to an unoccupied space it can see within 30 feet of it.",
        ],
      },
      {
        name: "Crystal",
        entries: [
          "The gem stalker gains a number of temporary hit points equal to the damage dealt.",
        ],
      },
      {
        name: "Emerald",
        entries: [
          "The target must roll a {@dice d4} and subtract the number rolled from the next attack roll it makes before the start of the gem stalker's next turn.",
        ],
      },
      {
        name: "Sapphire",
        entries: [
          "The target must succeed on a {@dc 13} Strength saving throw or be pushed horizontally up to 10 feet away from the gem stalker and be knocked {@condition prone}.",
        ],
      },
      {
        name: "Topaz",
        entries: [
          "The target must succeed on a {@dc 13} Constitution saving throw or be {@condition poisoned} until the start of the gem stalker's next turn.",
        ],
      },
    ],
    reaction: [
      {
        name: "Protective Link",
        entries: [
          "When another creature the gem stalker can see within 30 feet of it is about to take damage, the gem stalker reduces that damage by 10 ({@dice 3d6}). The gem stalker then takes damage equal to that amount.",
        ],
      },
    ],
    traitTags: ["Spider Climb", "Unusual Nature"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["CS", "DR", "TP"],
    damageTags: ["O", "S"],
    miscTags: ["MW"],
    conditionInflict: ["poisoned", "prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Ghost Dragon",
    source: "FTD",
    page: 203,
    size: ["H"],
    type: "undead",
    alignment: ["A"],
    ac: [10],
    hp: {
      average: 324,
      formula: "24d12 + 168",
    },
    speed: {
      walk: 40,
      fly: {
        number: 80,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 20,
    dex: 10,
    con: 25,
    int: 16,
    wis: 15,
    cha: 19,
    save: {
      con: "+13",
      wis: "+8",
      cha: "+10",
    },
    skill: {
      perception: "+14",
      stealth: "+12",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 24,
    resist: ["bludgeoning", "piercing", "slashing"],
    immune: ["acid", "cold", "necrotic", "poison"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "grappled",
      "paralyzed",
      "petrified",
      "poisoned",
      "prone",
      "restrained",
    ],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: "17",
    trait: [
      {
        name: "Incorporeal Movement",
        entries: [
          "The ghost dragon can move through other creatures and objects as if they were {@quickref difficult terrain||3}. It takes 5 ({@damage 1d10}) force damage if it ends its turn inside an object.",
        ],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the ghost dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: [
          "The ghost dragon doesn't require air, food, drink, or sleep.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The ghost dragon makes one Bite attack and two Claw attacks.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 11} to hit, reach 10 ft., one target. {@h}32 ({@damage 6d8 + 5}) cold damage, and the target's speed is halved until the start of the dragon's next turn.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 11} to hit, reach 5 ft., one target. {@h}14 ({@damage 2d8 + 5}) necrotic damage.",
        ],
      },
      {
        name: "Terrifying Breath {@recharge}",
        entries: [
          "The ghost dragon exhales shadowy mist in a 90-foot cone. Each creature in that area must make a {@dc 21} Constitution saving throw. On a failed save, the creature takes 40 ({@damage 9d8}) cold damage and is {@condition frightened} of the ghost dragon for 1 minute. On a successful save, the creature takes half as much damage and isn't {@condition frightened}.",
          "While {@condition frightened} of the ghost dragon, a creature is {@condition paralyzed}. The {@condition frightened} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
          "If a creature's saving throw is successful or the effect ends for it, the creature is immune to this ghost dragon's Terrifying Breath for the next 24 hours.",
        ],
      },
    ],
    traitTags: [
      "Incorporeal Movement",
      "Legendary Resistances",
      "Unusual Nature",
    ],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["C", "N", "O"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["frightened", "paralyzed"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Giant Canary",
    source: "FTD",
    page: 23,
    size: ["L"],
    type: "beast",
    alignment: ["U"],
    ac: [12],
    hp: {
      average: 26,
      formula: "4d10 + 4",
    },
    speed: {
      walk: 30,
      fly: 60,
    },
    str: 10,
    dex: 14,
    con: 12,
    int: 2,
    wis: 10,
    cha: 6,
    passive: 10,
    cr: "1/2",
    action: [
      {
        name: "Peck",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d10 + 2}) piercing damage.",
        ],
      },
    ],
    damageTags: ["P"],
    miscTags: ["MW"],
    hasToken: true,
  },
  {
    name: "Gold Greatwyrm",
    group: ["Metallic Dragon"],
    source: "FTD",
    page: 208,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["metallic"],
    },
    alignment: ["L", "G"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 565,
      formula: "29d20 + 261",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 16,
    con: 29,
    int: 21,
    wis: 22,
    cha: 30,
    save: {
      dex: "+11",
      con: "+17",
      int: "+13",
      wis: "+14",
      cha: "+18",
    },
    skill: {
      insight: "+14",
      perception: "+22",
      persuasion: "+18",
    },
    senses: ["truesight 120 ft."],
    passive: 32,
    immune: ["fire"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic"],
    cr: "28",
    trait: [
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Metallic Awakening (Recharges after a Short or Long Rest)",
        entries: [
          'If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 450 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 120,000 XP (240,000 XP total) for defeating the greatwyrm after its Metallic Awakening activates.',
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) piercing damage plus 13 ({@damage 2d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} in this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 20 ft., one target. {@h}21 ({@damage 2d10 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 26} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm uses one of the following breath weapons:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                type: "item",
                name: "Elemental Breath",
                entries: [
                  "The greatwyrm exhales elemental energy in a 300-foot cone. Each creature in that area must make a {@dc 25} Dexterity saving throw, taking 84 ({@damage 13d12}) fire damage on a failed save, or half as much damage on a successful one.",
                ],
              },
              {
                type: "item",
                name: "Sapping Breath",
                entries: [
                  "The greatwyrm exhales gas in a 300-foot cone. Each creature in that area must make a {@dc 25} Constitution saving throw. On a failed save, the creature falls {@condition unconscious} for 1 minute. On a successful save, the creature has disadvantage on attack rolls and saving throws until the end of the greatwyrm's next turn. An {@condition unconscious} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
                ],
              },
            ],
          },
        ],
      },
      {
        name: "Change Shape",
        entries: [
          "The greatwyrm magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses its action to end it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The greatwyrm makes one Claw or Tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "The greatwyrm beats its wings. Each creature within 30 feet of it must succeed on a {@dc 26} Dexterity saving throw or take 17 ({@damage 2d6 + 10}) bludgeoning damage and be knocked {@condition prone}. The greatwyrm can then fly up to half its flying speed.",
        ],
      },
    ],
    mythicHeader: [
      "If the greatwyrm's Metallic Awakening trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The greatwyrm makes one Bite attack."],
      },
      {
        name: "Shattering Roar (Costs 2 Actions)",
        entries: [
          "The greatwyrm unleashes a magical roar. Each creature in a 120-foot-radius sphere centered on the greatwyrm must succeed on a {@dc 26} Constitution saving throw or take 19 ({@damage 3d12}) thunder damage and be {@condition incapacitated} until the end of its next turn.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Damage Absorption",
                    entries: [
                      "You might decide that this dragon is not only unharmed by fire damage, but actually healed by it.",
                      "Whenever the dragon is subjected to fire damage, it takes no damage and instead regains a number of hit points equal to the fire damage dealt.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 18} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "gold",
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "F", "O", "P", "S", "T"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: [
      "grappled",
      "incapacitated",
      "prone",
      "restrained",
      "unconscious",
    ],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Green Greatwyrm",
    group: ["Chromatic Dragon"],
    source: "FTD",
    page: 168,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["chromatic"],
    },
    alignment: ["C", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 533,
      formula: "26d20 + 260",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 14,
    con: 30,
    int: 21,
    wis: 20,
    cha: 26,
    save: {
      dex: "+10",
      con: "+18",
      wis: "+13",
      cha: "+16",
    },
    skill: {
      intimidation: "+16",
      perception: "+21",
      stealth: "+10",
    },
    senses: ["truesight 120 ft."],
    passive: 31,
    immune: ["poison"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic"],
    cr: "27",
    trait: [
      {
        name: "Chromatic Awakening (Recharges after a Short or Long Rest)",
        entries: [
          'If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 425 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 105,000 XP (210,000 XP total) for defeating the greatwyrm after its Chromatic Awakening activates.',
        ],
      },
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) piercing damage plus 13 ({@damage 2d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 20 ft., one target. {@h}19 ({@damage 2d8 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 26} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm exhales a blast of energy in a 300-foot cone. Each creature in that area must make a {@dc 26} Dexterity saving throw. On a failed save, the creature takes 78 ({@damage 12d12}) poison damage. On a successful save, the creature takes half as much damage.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The greatwyrm makes one Claw or Tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "The greatwyrm beats its wings. Each creature within 30 feet of it must succeed on a {@dc 26} Dexterity saving throw or take 17 ({@damage 2d6 + 10}) bludgeoning damage and be knocked {@condition prone}. The greatwyrm can then fly up to half its flying speed.",
        ],
      },
      {
        name: "Arcane Spear (Costs 3 Actions)",
        entries: [
          "The greatwyrm creates four spears of magical force. Each spear hits a creature of the greatwyrm's choice it can see within 120 feet of it, dealing 12 ({@damage 1d8 + 8}) force damage to its target, then disappears.",
        ],
      },
    ],
    mythicHeader: [
      "If the greatwyrm's Chromatic Awakening trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The greatwyrm makes one Bite attack."],
      },
      {
        name: "Chromatic Flare (Costs 2 Actions)",
        entries: [
          "The greatwyrm flares with elemental energy. Each creature in a 60-foot-radius sphere centered on the greatwyrm must succeed on a {@dc 26} Dexterity saving throw or take 22 ({@damage 5d8}) poison damage.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 16} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "green",
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "I", "O", "P", "S"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Hoard Mimic",
    source: "FTD",
    page: 204,
    size: ["H"],
    type: "monstrosity",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 123,
      formula: "13d12 + 39",
    },
    speed: {
      walk: 30,
    },
    str: 21,
    dex: 12,
    con: 17,
    int: 10,
    wis: 16,
    cha: 10,
    save: {
      con: "+6",
      wis: "+6",
    },
    skill: {
      persuasion: "+3",
      stealth: "+6",
    },
    senses: ["darkvision 60 ft."],
    passive: 13,
    conditionImmune: ["prone"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: "8",
    trait: [
      {
        name: "False Appearance (Hoard Form Only)",
        entries: [
          "If the mimic is motionless at the start of combat, it has advantage on its initiative roll. Moreover, if a creature hasn't observed the mimic move or act, that creature must succeed on a {@dc 18} Intelligence (Investigation) check to discern that the mimic is animate.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The mimic makes one Bite attack and two Pseudopod attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 5 ft., one creature. {@h}16 ({@damage 2d10 + 5}) piercing damage plus 7 ({@damage 2d6}) acid damage.",
        ],
      },
      {
        name: "Pseudopod",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 10 ft., one target. {@h}12 ({@damage 2d6 + 5}) bludgeoning damage, and the mimic adheres to the target. A creature adhered to the mimic is also {@condition grappled} by it (escape {@dc 16}). Until this grapple ends, the target is {@condition restrained}. Ability checks made to escape this grapple have disadvantage.",
        ],
      },
      {
        name: "Caustic Mist {@recharge 5}",
        entries: [
          "The mimic sprays a fine mist of acid in a 30-foot cone. Each creature in that area must make a {@dc 14} Dexterity saving throw. On a failed save, the creature takes 27 ({@damage 6d8}) acid damage and is {@condition blinded} until the end of its next turn. On a successful save, the creature takes half as much damage and isn't {@condition blinded}.",
        ],
      },
      {
        name: "Shapechanger",
        entries: [
          "The mimic transforms into a hoard or back into its true, amorphous form. Its statistics are the same in each form. Any equipment it is wearing or carrying isn't transformed. It reverts to its true form if it dies.",
        ],
      },
    ],
    traitTags: ["False Appearance"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["A", "B", "P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["blinded", "grappled", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Hoard Scarab",
    source: "FTD",
    page: 205,
    size: ["T"],
    type: "monstrosity",
    alignment: ["U"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 7,
      formula: "3d4",
    },
    speed: {
      walk: 20,
      burrow: 20,
      fly: 20,
    },
    str: 4,
    dex: 16,
    con: 11,
    int: 3,
    wis: 8,
    cha: 6,
    senses: ["darkvision 60 ft.", "tremorsense 60 ft."],
    passive: 9,
    cr: "1/8",
    trait: [
      {
        name: "False Appearance",
        entries: [
          "If the scarab is motionless at the start of combat, it has advantage on its initiative roll. Moreover, if a creature hasn't observed the scarab move or act, that creature must succeed on a {@dc 18} Intelligence (Investigation) check to discern that the scarab is animate.",
        ],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}5 ({@damage 1d4 + 3}) piercing damage. If the target is a creature, it has disadvantage on attack rolls until the start of its next turn.",
        ],
      },
    ],
    bonus: [
      {
        name: "Scale Dust (1/Day)",
        entries: [
          "The scarab releases magical glittering dust from its wings. Each creature within 5 feet of the scarab must succeed on a {@dc 13} Dexterity saving throw or be outlined in blue light for 10 minutes. While outlined in this way, a creature sheds dim light in a 10-foot radius and can't benefit from being {@condition invisible}. In addition, every Dragon within 1 mile of the creature becomes aware of it and can unerringly track the creature. Casting {@spell dispel magic} on the creature ends the effect on it.",
        ],
      },
    ],
    traitTags: ["False Appearance"],
    senseTags: ["D", "T"],
    damageTags: ["P"],
    miscTags: ["AOE", "MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Hollow Dragon",
    source: "FTD",
    page: 206,
    size: ["H"],
    type: "undead",
    alignment: ["A"],
    ac: [
      {
        ac: 19,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 241,
      formula: "21d12 + 105",
    },
    speed: {
      walk: 40,
      fly: 80,
    },
    str: 23,
    dex: 12,
    con: 21,
    int: 16,
    wis: 13,
    cha: 21,
    save: {
      con: "+11",
      int: "+9",
      wis: "+7",
      cha: "+11",
    },
    skill: {
      arcana: "+9",
      history: "+15",
      perception: "+13",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 23,
    resist: ["necrotic"],
    immune: ["poison", "radiant"],
    conditionImmune: [
      "charmed",
      "deafened",
      "exhaustion",
      "frightened",
      "paralyzed",
      "poisoned",
    ],
    languages: ["Common", "Draconic"],
    cr: "18",
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the hollow dragon fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Reconstruction",
        entries: [
          "When the hollow dragon is reduced to 0 hit points, its body breaks into nine pieces: two arms, two legs, two wings, a tail, a torso, and a head. Each piece is a Large object with AC 19, 27 hit points, and immunity to psychic and poison damage. After {@dice 1d6} days, if all pieces are still within 6 miles of each other, they all teleport to the location of the head piece and merge with it, whereupon the hollow dragon regains all its hit points and becomes active again.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The hollow dragon makes one Bite attack and two Claw attacks, and it can use Sapping Presence.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 10 ft., one target. {@h}17 ({@damage 2d10 + 6}) piercing damage plus 9 ({@damage 2d8}) radiant damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 5 ft., one target. {@h}13 ({@damage 2d6 + 6}) slashing damage.",
        ],
      },
      {
        name: "Sapping Presence",
        entries: [
          "Each creature of the hollow dragon's choice within 60 feet of it must make a {@dc 19} Wisdom saving throw. On a failed save, the creature's speed is halved and it has disadvantage on attack rolls until the end of its next turn. On a successful save, the creature is immune to this hollow dragon's Sapping Presence for 24 hours.",
        ],
      },
      {
        name: "Radiant Breath {@recharge 5}",
        entries: [
          "The hollow dragon exhales radiant flames in a 60-foot cone. Each creature in that area must make a {@dc 19} Dexterity saving throw, taking 54 ({@damage 12d8}) radiant damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The hollow dragon makes one Claw attack."],
      },
      {
        name: "Ghostly Binding (Costs 2 Actions)",
        entries: [
          "The hollow dragon creates ethereal bindings around a creature it can see within 60 feet of it. The target must succeed on a {@dc 19} Strength saving throw or be {@condition restrained} until the end of the dragon's next turn.",
        ],
      },
      {
        name: "Booming Scales (Costs 3 Actions)",
        entries: [
          "A sudden loud ringing noise, painfully intense, erupts from the hollow dragon's frame. Each creature within 10 feet of the hollow dragon must make a {@dc 19} Constitution saving throw, taking 24 ({@damage 7d6}) thunder damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    traitTags: ["Legendary Resistances"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["P", "R", "S", "T"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Liondrake",
    source: "FTD",
    page: 207,
    size: ["L"],
    type: "monstrosity",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 119,
      formula: "14d10 + 42",
    },
    speed: {
      walk: 40,
      fly: 60,
    },
    str: 19,
    dex: 15,
    con: 17,
    int: 6,
    wis: 12,
    cha: 12,
    skill: {
      perception: "+7",
    },
    senses: ["darkvision 60 ft."],
    passive: 17,
    languages: ["Draconic"],
    cr: "7",
    action: [
      {
        name: "Multiattack",
        entries: ["The liondrake makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}15 ({@damage 2d10 + 4}) piercing damage. If the target is a Medium or smaller creature, it must succeed on a {@dc 15} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}11 ({@damage 2d6 + 4}) slashing damage.",
        ],
      },
      {
        name: "Blood-Chilling Roar {@recharge 4}",
        entries: [
          "The liondrake lets out a terrifying roar audible out to 300 feet. Any creature within 30 feet of the liondrake that can hear its roar must succeed on a {@dc 14} Wisdom saving throw or be {@condition frightened} of the liondrake for 1 minute. A creature that fails the save by 5 or more is also {@condition paralyzed} for the same duration. A creature can repeat the saving throw at the end of its turns, ending the effect on itself on a success. If a target's saving throw is successful or the effect ends for it, the target is immune to this liondrake's Blood-Chilling Roar for the next 24 hours.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["DR"],
    damageTags: ["P", "S"],
    miscTags: ["MW"],
    conditionInflict: ["frightened", "paralyzed", "prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Metallic Peacekeeper",
    source: "FTD",
    page: 210,
    size: ["M"],
    type: "construct",
    alignment: ["N", "G"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 68,
      formula: "8d8 + 32",
    },
    speed: {
      walk: 30,
    },
    str: 17,
    dex: 10,
    con: 18,
    int: 14,
    wis: 12,
    cha: 11,
    senses: ["darkvision 60 ft."],
    passive: 11,
    immune: ["fire"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["Common", "Draconic", "telepathy 30 ft."],
    cr: "4",
    trait: [
      {
        name: "Immutable Form",
        entries: [
          "The peacekeeper is immune to any spell or effect that would alter its form.",
        ],
      },
      {
        name: "Telepathic Bond",
        entries: [
          "While the peacekeeper is on the same plane of existence as its master, it can magically convey what it senses to its master, and the two can communicate telepathically with each other.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The peacekeeper makes two Slam attacks."],
      },
      {
        name: "Slam",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}16 ({@damage 3d8 + 3}) bludgeoning damage.",
        ],
      },
      {
        name: "Calming Mist {@recharge 5}",
        entries: [
          "The peacekeeper releases a calming gas in a 30-foot-radius sphere centered on itself. Each creature in that area must succeed on a {@dc 14} Charisma saving throw or become {@condition charmed} by the peacekeeper for 1 minute. While {@condition charmed} in this way, the creature is {@condition incapacitated} and has a speed of 0.",
        ],
      },
    ],
    traitTags: ["Immutable Form"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["B"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["charmed", "incapacitated"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Metallic Warbler",
    source: "FTD",
    page: 210,
    size: ["T"],
    type: "construct",
    alignment: ["N", "G"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 14,
      formula: "4d4 + 4",
    },
    speed: {
      walk: 40,
      fly: 60,
    },
    str: 4,
    dex: 15,
    con: 12,
    int: 9,
    wis: 10,
    cha: 12,
    save: {
      dex: "+4",
    },
    senses: ["darkvision 60 ft."],
    passive: 10,
    immune: ["fire"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["understands Common and Draconic but can't speak"],
    cr: "1/4",
    trait: [
      {
        name: "Immutable Form",
        entries: [
          "The warbler is immune to any spell or effect that would alter its form.",
        ],
      },
      {
        name: "Telepathic Bond",
        entries: [
          "While the warbler is on the same plane of existence as its master, it can magically convey what it senses to its master, and the two can communicate telepathically with each other.",
        ],
      },
    ],
    action: [
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d4 + 2}) slashing damage.",
        ],
      },
      {
        name: "Calming Mist {@recharge 5}",
        entries: [
          "The warbler releases a calming gas in a 5-foot-radius sphere centered on itself. Each creature in that area must succeed on a {@dc 11} Charisma saving throw or become {@condition charmed} by the warbler for 1 minute. While {@condition charmed} in this way, the creature is {@condition incapacitated} and has a speed of 0.",
        ],
      },
    ],
    traitTags: ["Immutable Form"],
    senseTags: ["D"],
    languageTags: ["C", "CS", "DR"],
    damageTags: ["S"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["charmed", "incapacitated"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Moonstone Dragon Wyrmling",
    source: "FTD",
    page: 213,
    size: ["M"],
    type: "dragon",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 39,
      formula: "6d8 + 12",
    },
    speed: {
      walk: 30,
      fly: 60,
    },
    str: 16,
    dex: 14,
    con: 14,
    int: 16,
    wis: 14,
    cha: 17,
    save: {
      int: "+5",
      wis: "+4",
      cha: "+5",
    },
    skill: {
      perception: "+4",
      persuasion: "+5",
      stealth: "+4",
    },
    senses: ["blindsight 10 ft.", "darkvision 60 ft."],
    passive: 14,
    conditionImmune: ["charmed"],
    languages: ["Draconic"],
    cr: "2",
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 10 ft., one target. {@h}12 ({@damage 2d8 + 3}) piercing damage plus 3 ({@damage 1d6}) radiant damage.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The dragon uses one of the following breath weapons:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                type: "item",
                name: "Dream Breath",
                entries: [
                  "The dragon exhales mist in a 90-foot cone. Each creature in that area must succeed on a {@dc 12} Constitution saving throw or fall {@condition unconscious} for 10 minutes. This effect ends for a creature if the creature takes damage or someone uses an action to wake it.",
                ],
              },
              {
                type: "item",
                name: "Moonlight Breath",
                entries: [
                  "The dragon exhales a beam of moonlight in a 30-foot line that is 5 feet wide. Each creature in that area must make a {@dc 12} Dexterity saving throw, taking 14 ({@damage 4d6}) radiant damage on a failed save, or half as much damage on a successful one.",
                ],
              },
            ],
          },
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 11} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "wyrmling",
    senseTags: ["B", "D"],
    actionTags: ["Breath Weapon"],
    languageTags: ["DR"],
    damageTags: ["P", "R"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["unconscious"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Red Greatwyrm",
    group: ["Chromatic Dragon"],
    source: "FTD",
    page: 168,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["chromatic"],
    },
    alignment: ["C", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 533,
      formula: "26d20 + 260",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 14,
    con: 30,
    int: 21,
    wis: 20,
    cha: 26,
    save: {
      dex: "+10",
      con: "+18",
      wis: "+13",
      cha: "+16",
    },
    skill: {
      intimidation: "+16",
      perception: "+21",
      stealth: "+10",
    },
    senses: ["truesight 120 ft."],
    passive: 31,
    immune: ["fire"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic"],
    cr: "27",
    trait: [
      {
        name: "Chromatic Awakening (Recharges after a Short or Long Rest)",
        entries: [
          'If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 425 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 105,000 XP (210,000 XP total) for defeating the greatwyrm after its Chromatic Awakening activates.',
        ],
      },
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) piercing damage plus 13 ({@damage 2d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 20 ft., one target. {@h}19 ({@damage 2d8 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 26} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm exhales a blast of energy in a 300-foot cone. Each creature in that area must make a {@dc 26} Dexterity saving throw. On a failed save, the creature takes 78 ({@damage 12d12}) fire damage. On a successful save, the creature takes half as much damage.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The greatwyrm makes one Claw or Tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "The greatwyrm beats its wings. Each creature within 30 feet of it must succeed on a {@dc 26} Dexterity saving throw or take 17 ({@damage 2d6 + 10}) bludgeoning damage and be knocked {@condition prone}. The greatwyrm can then fly up to half its flying speed.",
        ],
      },
      {
        name: "Arcane Spear (Costs 3 Actions)",
        entries: [
          "The greatwyrm creates four spears of magical force. Each spear hits a creature of the greatwyrm's choice it can see within 120 feet of it, dealing 12 ({@damage 1d8 + 8}) force damage to its target, then disappears.",
        ],
      },
    ],
    mythicHeader: [
      "If the greatwyrm's Chromatic Awakening trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The greatwyrm makes one Bite attack."],
      },
      {
        name: "Chromatic Flare (Costs 2 Actions)",
        entries: [
          "The greatwyrm flares with elemental energy. Each creature in a 60-foot-radius sphere centered on the greatwyrm must succeed on a {@dc 26} Dexterity saving throw or take 22 ({@damage 5d8}) fire damage.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Damage Absorption",
                    entries: [
                      "You might decide that this dragon is not only unharmed by fire damage, but actually healed by it.",
                      "Whenever the dragon is subjected to fire damage, it takes no damage and instead regains a number of hit points equal to the fire damage dealt.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 16} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "red",
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "F", "O", "P", "S"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Sapphire Dragon Wyrmling",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 216,
    size: ["M"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["L", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 45,
      formula: "6d8 + 18",
    },
    speed: {
      walk: 30,
      burrow: 15,
      climb: 30,
      fly: 60,
    },
    str: 17,
    dex: 14,
    con: 16,
    int: 14,
    wis: 13,
    cha: 14,
    save: {
      dex: "+4",
      con: "+5",
      wis: "+3",
      cha: "+4",
    },
    skill: {
      history: "+4",
      perception: "+5",
      persuasion: "+6",
      stealth: "+4",
    },
    senses: ["blindsight 30 ft.", "darkvision 120 ft."],
    passive: 15,
    resist: ["lightning", "thunder"],
    conditionImmune: ["frightened"],
    languages: ["Draconic", "telepathy 120 ft."],
    cr: "3",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability:",
        ],
        daily: {
          "1e": ["{@spell alarm}", "{@spell Tenser's floating disk}"],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Spider Climb",
        entries: [
          "The dragon can climb difficult surfaces, including upside down on ceilings, without needing to make an ability check.",
        ],
      },
      {
        name: "Tunneler",
        entries: [
          "The dragon can burrow through solid rock at half its burrowing speed and can leave a 5-foot-diameter tunnel in its wake.",
        ],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d10 + 3}) piercing damage plus 3 ({@damage 1d6}) thunder damage.",
        ],
      },
      {
        name: "Debilitating Breath {@recharge 5}",
        entries: [
          "The dragon exhales a pulse of high-pitched, nearly inaudible sound in a 15-foot cone. Each creature in that area must make a {@dc 13} Constitution saving throw. On a failed save, the creature takes 22 ({@damage 4d10}) thunder damage and is {@condition incapacitated} until the end of its next turn. On a successful save, the creature takes half as much damage and isn't {@condition incapacitated}.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 10} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "wyrmling",
    traitTags: ["Spider Climb", "Tunneler"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon"],
    languageTags: ["DR", "TP"],
    damageTags: ["P", "T"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["incapacitated"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Sapphire Greatwyrm",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 201,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 21,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 507,
      formula: "26d20 + 234",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: {
        number: 120,
        condition: "(hover)",
      },
      swim: 60,
      canHover: true,
    },
    str: 28,
    dex: 14,
    con: 29,
    int: 30,
    wis: 24,
    cha: 25,
    save: {
      dex: "+10",
      con: "+17",
      wis: "+15",
      cha: "+15",
    },
    skill: {
      arcana: "+26",
      history: "+18",
      perception: "+15",
    },
    senses: ["truesight 120 ft."],
    passive: 25,
    immune: ["thunder"],
    conditionImmune: ["charmed", "frightened", "poisoned", "prone"],
    languages: ["Common", "Draconic"],
    cr: "26",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The greatwyrm casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 26}, {@hit 18} to hit with spell attack):",
        ],
        daily: {
          "1e": [
            "{@spell dispel magic}",
            "{@spell forcecage}",
            "{@spell plane shift}",
            "{@spell reverse gravity}",
            "{@spell time stop}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Gem Awakening (Recharges after a Short or Long Rest)",
        entries: [
          "If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 400 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use its Mass Telekinesis action during the next hour. Award a party an additional 90,000 XP (180,000 XP total) for defeating the greatwyrm after its Gem Awakening activates.",
        ],
      },
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 17} to hit, reach 15 ft., one target. {@h}20 ({@damage 2d10 + 9}) piercing damage plus 16 ({@damage 3d10}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 17} to hit, reach 10 ft., one target. {@h}18 ({@damage 2d8 + 9}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 19}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} in this way at a time.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm exhales crushing force in a 300-foot cone. Each creature in that area must make a {@dc 25} Dexterity saving throw. On a failed save, the creature takes 71 ({@damage 11d12}) force damage and is knocked {@condition prone}. On a successful save, it takes half as much damage and isn't knocked {@condition prone}. On a success or failure, the creature's speed becomes 0 until the end of its next turn.",
        ],
      },
      {
        name: "Mass Telekinesis (Gem Awakening Only; Recharges after a Short or Long Rest)",
        entries: [
          "The greatwyrm targets any number of creatures and objects it can see within 120 feet of it. No one target can weigh more than 4,000 pounds, and objects can't be targeted if they're being worn or carried. Each targeted creature must succeed on a {@dc 26} Strength saving throw or be {@condition restrained} in the greatwyrm's telekinetic grip. At the end of a creature's turn, it can repeat the saving throw, ending the effect on itself on a success.",
          "At the end of the greatwyrm's turn, it can move each creature or object it has in its telekinetic grip up to 60 feet in any direction, but not beyond 120 feet of itself. In addition, it can choose any number of creatures {@condition restrained} in this way and deal 45 ({@damage 7d12}) force damage to each of them.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The greatwyrm magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the greatwyrm is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The greatwyrm magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The greatwyrm makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The greatwyrm uses Psychic Step or Spellcasting."],
      },
      {
        name: "Psychic Beam (Costs 3 Actions)",
        entries: [
          "The greatwyrm emits a beam of psychic energy in a 90-foot line that is 10 feet wide. Each creature in that area must make a {@dc 26} Intelligence saving throw, taking 27 ({@damage 5d10}) psychic damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 15} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["O", "P", "S", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Silver Greatwyrm",
    group: ["Metallic Dragon"],
    source: "FTD",
    page: 208,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["metallic"],
    },
    alignment: ["L", "G"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 565,
      formula: "29d20 + 261",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 16,
    con: 29,
    int: 21,
    wis: 22,
    cha: 30,
    save: {
      dex: "+11",
      con: "+17",
      int: "+13",
      wis: "+14",
      cha: "+18",
    },
    skill: {
      insight: "+14",
      perception: "+22",
      persuasion: "+18",
    },
    senses: ["truesight 120 ft."],
    passive: 32,
    immune: ["cold"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic"],
    cr: "28",
    trait: [
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Metallic Awakening (Recharges after a Short or Long Rest)",
        entries: [
          'If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 450 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 120,000 XP (240,000 XP total) for defeating the greatwyrm after its Metallic Awakening activates.',
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) piercing damage plus 13 ({@damage 2d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} in this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 20 ft., one target. {@h}21 ({@damage 2d10 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 26} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm uses one of the following breath weapons:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                type: "item",
                name: "Elemental Breath",
                entries: [
                  "The greatwyrm exhales elemental energy in a 300-foot cone. Each creature in that area must make a {@dc 25} Dexterity saving throw, taking 84 ({@damage 13d12}) cold damage on a failed save, or half as much damage on a successful one.",
                ],
              },
              {
                type: "item",
                name: "Sapping Breath",
                entries: [
                  "The greatwyrm exhales gas in a 300-foot cone. Each creature in that area must make a {@dc 25} Constitution saving throw. On a failed save, the creature falls {@condition unconscious} for 1 minute. On a successful save, the creature has disadvantage on attack rolls and saving throws until the end of the greatwyrm's next turn. An {@condition unconscious} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
                ],
              },
            ],
          },
        ],
      },
      {
        name: "Change Shape",
        entries: [
          "The greatwyrm magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the dragon is reduced to 0 hit points or uses its action to end it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The greatwyrm makes one Claw or Tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "The greatwyrm beats its wings. Each creature within 30 feet of it must succeed on a {@dc 26} Dexterity saving throw or take 17 ({@damage 2d6 + 10}) bludgeoning damage and be knocked {@condition prone}. The greatwyrm can then fly up to half its flying speed.",
        ],
      },
    ],
    mythicHeader: [
      "If the greatwyrm's Metallic Awakening trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The greatwyrm makes one Bite attack."],
      },
      {
        name: "Shattering Roar (Costs 2 Actions)",
        entries: [
          "The greatwyrm unleashes a magical roar. Each creature in a 120-foot-radius sphere centered on the greatwyrm must succeed on a {@dc 26} Constitution saving throw or take 19 ({@damage 3d12}) thunder damage and be {@condition incapacitated} until the end of its next turn.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 18} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "silver",
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "C", "O", "P", "S", "T"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: [
      "grappled",
      "incapacitated",
      "prone",
      "restrained",
      "unconscious",
    ],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Swarm of Hoard Scarabs",
    source: "FTD",
    page: 205,
    size: ["M"],
    type: {
      type: "monstrosity",
      swarmSize: "T",
    },
    alignment: ["U"],
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 31,
      formula: "7d8",
    },
    speed: {
      walk: 20,
      burrow: 20,
      fly: 20,
    },
    str: 6,
    dex: 16,
    con: 11,
    int: 3,
    wis: 8,
    cha: 6,
    senses: ["darkvision 60 ft.", "tremorsense 60 ft."],
    passive: 9,
    resist: ["bludgeoning", "piercing", "slashing"],
    conditionImmune: [
      "charmed",
      "frightened",
      "grappled",
      "paralyzed",
      "petrified",
      "prone",
      "restrained",
      "stunned",
    ],
    cr: "2",
    trait: [
      {
        name: "False Appearance",
        entries: [
          "If the swarm is motionless at the start of combat, it has advantage on its initiative roll. Moreover, if a creature hasn't observed the swarm move or act, that creature must succeed on a {@dc 18} Intelligence (Investigation) check to discern that the swarm is animate.",
        ],
      },
      {
        name: "Swarm",
        entries: [
          "The swarm can occupy another creature's space and vice versa, and the swarm can move through any opening large enough for a Tiny scarab. The swarm can't regain hit points or gain temporary hit points.",
        ],
      },
    ],
    action: [
      {
        name: "Swarm of Bites",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 0 ft., one creature in the swarm's space. {@h}13 ({@damage 3d6 + 3}) piercing damage, or 6 ({@damage 1d6 + 3}) piercing damage if the swarm is at half of its hit points or fewer, and the target has disadvantage on attack rolls until the start of its next turn.",
        ],
      },
    ],
    bonus: [
      {
        name: "Scale Dust (1/Day)",
        entries: [
          "The swarm releases magical glittering dust from its wings. Each creature within 10 feet of the swarm must succeed on a {@dc 13} Dexterity saving throw or be outlined in blue light for 10 minutes. While outlined in this way, a creature sheds dim light in a 10-foot radius and can't benefit from being {@condition invisible}. In addition, every Dragon within 1 mile of the creature becomes aware of it and can unerringly track the creature. Casting {@spell dispel magic} on the creature ends the effect on it.",
        ],
      },
    ],
    traitTags: ["False Appearance"],
    senseTags: ["D", "T"],
    damageTags: ["P"],
    miscTags: ["AOE", "MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Topaz Dragon Wyrmling",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 223,
    size: ["M"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["C", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 33,
      formula: "6d8 + 6",
    },
    speed: {
      walk: 30,
      fly: 60,
      swim: 30,
    },
    str: 15,
    dex: 12,
    con: 13,
    int: 14,
    wis: 13,
    cha: 14,
    save: {
      dex: "+3",
      con: "+3",
      wis: "+3",
      cha: "+4",
    },
    skill: {
      intimidation: "+6",
      perception: "+5",
      stealth: "+3",
    },
    senses: ["blindsight 10 ft.", "darkvision 120 ft."],
    passive: 15,
    resist: ["cold", "necrotic"],
    languages: ["Draconic"],
    cr: "2",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 12}):",
        ],
        daily: {
          "1e": ["{@spell bane}"],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon can breathe both air and water."],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d10 + 2}) piercing damage plus 2 ({@damage 1d4}) necrotic damage.",
        ],
      },
      {
        name: "Desiccating Breath {@recharge 5}",
        entries: [
          "The dragon exhales yellowish necrotic energy in a 15-foot cone. Each creature in that area must make a {@dc 11} Constitution saving throw. On a failed save, the creature takes 21 ({@damage 6d6}) necrotic damage and is weakened until the end of its next turn. A weakened creature has disadvantage on Strength-based ability checks and Strength saving throws, and the creature's weapon attacks that rely on Strength deal half damage. On a successful save, the creature takes half as much damage and isn't weakened.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 10} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "wyrmling",
    traitTags: ["Amphibious"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon"],
    languageTags: ["DR"],
    damageTags: ["N", "P"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Topaz Greatwyrm",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 201,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 21,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 507,
      formula: "26d20 + 234",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: {
        number: 120,
        condition: "(hover)",
      },
      swim: 60,
      canHover: true,
    },
    str: 28,
    dex: 14,
    con: 29,
    int: 30,
    wis: 24,
    cha: 25,
    save: {
      dex: "+10",
      con: "+17",
      wis: "+15",
      cha: "+15",
    },
    skill: {
      arcana: "+26",
      history: "+18",
      perception: "+15",
    },
    senses: ["truesight 120 ft."],
    passive: 25,
    immune: ["necrotic"],
    conditionImmune: ["charmed", "frightened", "poisoned", "prone"],
    languages: ["Common", "Draconic"],
    cr: "26",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The greatwyrm casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 26}, {@hit 18} to hit with spell attack):",
        ],
        daily: {
          "1e": [
            "{@spell dispel magic}",
            "{@spell forcecage}",
            "{@spell plane shift}",
            "{@spell reverse gravity}",
            "{@spell time stop}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Gem Awakening (Recharges after a Short or Long Rest)",
        entries: [
          "If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 400 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use its Mass Telekinesis action during the next hour. Award a party an additional 90,000 XP (180,000 XP total) for defeating the greatwyrm after its Gem Awakening activates.",
        ],
      },
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 17} to hit, reach 15 ft., one target. {@h}20 ({@damage 2d10 + 9}) piercing damage plus 16 ({@damage 3d10}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 17} to hit, reach 10 ft., one target. {@h}18 ({@damage 2d8 + 9}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 19}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} in this way at a time.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm exhales crushing force in a 300-foot cone. Each creature in that area must make a {@dc 25} Dexterity saving throw. On a failed save, the creature takes 71 ({@damage 11d12}) force damage and is knocked {@condition prone}. On a successful save, it takes half as much damage and isn't knocked {@condition prone}. On a success or failure, the creature's speed becomes 0 until the end of its next turn.",
        ],
      },
      {
        name: "Mass Telekinesis (Gem Awakening Only; Recharges after a Short or Long Rest)",
        entries: [
          "The greatwyrm targets any number of creatures and objects it can see within 120 feet of it. No one target can weigh more than 4,000 pounds, and objects can't be targeted if they're being worn or carried. Each targeted creature must succeed on a {@dc 26} Strength saving throw or be {@condition restrained} in the greatwyrm's telekinetic grip. At the end of a creature's turn, it can repeat the saving throw, ending the effect on itself on a success.",
          "At the end of the greatwyrm's turn, it can move each creature or object it has in its telekinetic grip up to 60 feet in any direction, but not beyond 120 feet of itself. In addition, it can choose any number of creatures {@condition restrained} in this way and deal 45 ({@damage 7d12}) force damage to each of them.",
        ],
      },
    ],
    bonus: [
      {
        name: "Change Shape",
        entries: [
          "The greatwyrm magically transforms into any creature that is Medium or Small, while retaining its game statistics (other than its size). This transformation ends if the greatwyrm is reduced to 0 hit points or uses a bonus action to end it.",
        ],
      },
      {
        name: "Psychic Step",
        entries: [
          "The greatwyrm magically teleports to an unoccupied space it can see within 60 feet of it.",
        ],
      },
    ],
    legendary: [
      {
        name: "Claw",
        entries: ["The greatwyrm makes one Claw attack."],
      },
      {
        name: "Psionics (Costs 2 Actions)",
        entries: ["The greatwyrm uses Psychic Step or Spellcasting."],
      },
      {
        name: "Psychic Beam (Costs 3 Actions)",
        entries: [
          "The greatwyrm emits a beam of psychic energy in a 90-foot line that is 10 feet wide. Each creature in that area must make a {@dc 26} Intelligence saving throw, taking 27 ({@damage 5d10}) psychic damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 15} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack", "Shapechanger"],
    languageTags: ["C", "DR"],
    damageTags: ["O", "P", "S", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "White Greatwyrm",
    group: ["Chromatic Dragon"],
    source: "FTD",
    page: 168,
    size: ["G"],
    type: {
      type: "dragon",
      tags: ["chromatic"],
    },
    alignment: ["C", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 22,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 533,
      formula: "26d20 + 260",
    },
    speed: {
      walk: 60,
      burrow: 60,
      fly: 120,
      swim: 60,
    },
    str: 30,
    dex: 14,
    con: 30,
    int: 21,
    wis: 20,
    cha: 26,
    save: {
      dex: "+10",
      con: "+18",
      wis: "+13",
      cha: "+16",
    },
    skill: {
      intimidation: "+16",
      perception: "+21",
      stealth: "+10",
    },
    senses: ["truesight 120 ft."],
    passive: 31,
    immune: ["cold"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic"],
    cr: "27",
    trait: [
      {
        name: "Chromatic Awakening (Recharges after a Short or Long Rest)",
        entries: [
          'If the greatwyrm would be reduced to 0 hit points, its current hit point total instead resets to 425 hit points, it recharges its Breath Weapon, and it regains any expended uses of Legendary Resistance. Additionally, the greatwyrm can now use the options in the "Mythic Actions" section for 1 hour. Award a party an additional 105,000 XP (210,000 XP total) for defeating the greatwyrm after its Chromatic Awakening activates.',
        ],
      },
      {
        name: "Legendary Resistance (4/Day)",
        entries: [
          "If the greatwyrm fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The greatwyrm doesn't require food or drink."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The greatwyrm makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 15 ft., one target. {@h}21 ({@damage 2d10 + 10}) piercing damage plus 13 ({@damage 2d12}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 10 ft., one target. {@h}19 ({@damage 2d8 + 10}) slashing damage. If the target is a Huge or smaller creature, it is {@condition grappled} (escape {@dc 20}) and is {@condition restrained} until this grapple ends. The greatwyrm can have only one creature {@condition grappled} this way at a time.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 18} to hit, reach 20 ft., one target. {@h}19 ({@damage 2d8 + 10}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 26} Strength saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The greatwyrm exhales a blast of energy in a 300-foot cone. Each creature in that area must make a {@dc 26} Dexterity saving throw. On a failed save, the creature takes 78 ({@damage 12d12}) cold damage. On a successful save, the creature takes half as much damage.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The greatwyrm makes one Claw or Tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "The greatwyrm beats its wings. Each creature within 30 feet of it must succeed on a {@dc 26} Dexterity saving throw or take 17 ({@damage 2d6 + 10}) bludgeoning damage and be knocked {@condition prone}. The greatwyrm can then fly up to half its flying speed.",
        ],
      },
      {
        name: "Arcane Spear (Costs 3 Actions)",
        entries: [
          "The greatwyrm creates four spears of magical force. Each spear hits a creature of the greatwyrm's choice it can see within 120 feet of it, dealing 12 ({@damage 1d8 + 8}) force damage to its target, then disappears.",
        ],
      },
    ],
    mythicHeader: [
      "If the greatwyrm's Chromatic Awakening trait has activated in the last hour, it can use the options below as legendary actions.",
    ],
    mythic: [
      {
        name: "Bite",
        entries: ["The greatwyrm makes one Bite attack."],
      },
      {
        name: "Chromatic Flare (Costs 2 Actions)",
        entries: [
          "The greatwyrm flares with elemental energy. Each creature in a 60-foot-radius sphere centered on the greatwyrm must succeed on a {@dc 26} Dexterity saving throw or take 22 ({@damage 5d8}) cold damage.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 16} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "white",
    dragonAge: "greatwyrm",
    traitTags: ["Legendary Resistances", "Unusual Nature"],
    senseTags: ["U"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "C", "O", "P", "S"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Young Amethyst Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 161,
    size: ["L"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 18,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 168,
      formula: "16d10 + 80",
    },
    speed: {
      walk: 40,
      fly: {
        number: 80,
        condition: "(hover)",
      },
      swim: 40,
      canHover: true,
    },
    str: 21,
    dex: 12,
    con: 21,
    int: 18,
    wis: 15,
    cha: 19,
    save: {
      dex: "+5",
      con: "+9",
      wis: "+6",
      cha: "+8",
    },
    skill: {
      arcana: "+12",
      perception: "+10",
      persuasion: "+8",
      stealth: "+5",
    },
    senses: ["blindsight 30 ft.", "darkvision 120 ft."],
    passive: 20,
    resist: ["force", "psychic"],
    conditionImmune: ["frightened", "prone"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: "9",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 16}):",
        ],
        daily: {
          "1e": [
            "{@spell blink}",
            "{@spell dispel magic}",
            "{@spell protection from evil and good}",
            "{@spell sending}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon can breathe both air and water."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 10 ft., one target. {@h}16 ({@damage 2d10 + 5}) piercing damage plus 4 ({@damage 1d8}) force damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}9 ({@damage 1d8 + 5}) slashing damage.",
        ],
      },
      {
        name: "Singularity Breath {@recharge 5}",
        entries: [
          "The dragon creates a shining bead of gravitational force in its mouth, then releases the energy in a 30-foot cone. Each creature in that area must make a {@dc 17} Strength saving throw. On a failed save, the creature takes 36 ({@damage 8d8}) force damage, and its speed becomes 0 until the start of the dragon's next turn. On a successful save, the creature takes half as much damage, and its speed isn't reduced.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 12} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "young",
    traitTags: ["Amphibious"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["O", "P", "S"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Young Crystal Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 172,
    size: ["L"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["C", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 95,
      formula: "10d10 + 40",
    },
    speed: {
      walk: 40,
      burrow: 20,
      climb: 40,
      fly: 80,
    },
    str: 17,
    dex: 12,
    con: 18,
    int: 16,
    wis: 14,
    cha: 17,
    save: {
      dex: "+4",
      con: "+7",
      wis: "+5",
      cha: "+6",
    },
    skill: {
      perception: "+8",
      stealth: "+7",
      survival: "+5",
    },
    senses: ["blindsight 30 ft.", "darkvision 120 ft."],
    passive: 18,
    resist: ["cold", "radiant"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: "5",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 16}):",
        ],
        will: ["{@spell dancing lights}", "{@spell guidance}"],
        daily: {
          "1e": ["{@spell hypnotic pattern}", "{@spell lesser restoration}"],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 10 ft., one target. {@h}14 ({@damage 2d10 + 3}) piercing damage plus 4 ({@damage 1d8}) radiant damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}6 ({@damage 1d6 + 3}) slashing damage.",
        ],
      },
      {
        name: "Scintillating Breath {@recharge 5}",
        entries: [
          "The dragon exhales a burst of brilliant radiance in a 30-foot cone. Each creature in that area must make a {@dc 15} Constitution saving throw, taking 27 ({@damage 6d8}) radiant damage on a failed save, or half as much damage on a successful one. The dragon then gains 10 temporary hit points by absorbing a portion of the radiant energy.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 11} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "young",
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["P", "R", "S"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflictSpell: ["charmed", "incapacitated"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Young Deep Dragon",
    source: "FTD",
    page: 175,
    size: ["L"],
    type: "dragon",
    alignment: ["N", "E"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 93,
      formula: "11d10 + 33",
    },
    speed: {
      walk: 40,
      burrow: 20,
      fly: 80,
      swim: 40,
    },
    str: 18,
    dex: 13,
    con: 16,
    int: 12,
    wis: 14,
    cha: 16,
    save: {
      dex: "+4",
      con: "+6",
      wis: "+5",
      cha: "+6",
    },
    skill: {
      perception: "+5",
      persuasion: "+6",
      stealth: "+7",
    },
    senses: ["blindsight 30 ft.", "darkvision 150 ft."],
    passive: 15,
    resist: ["poison", "psychic"],
    conditionImmune: ["charmed", "frightened", "poisoned"],
    languages: ["Common", "Draconic", "Undercommon"],
    cr: "5",
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 10 ft., one target. {@h}9 ({@damage 1d10 + 4}) piercing damage plus 3 ({@damage 1d6}) poison damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d6 + 4}) slashing damage.",
        ],
      },
      {
        name: "Nightmare Breath {@recharge 5}",
        entries: [
          "The dragon exhales a cloud of spores in a 30-foot cone. Each creature in that area must make a {@dc 14} Wisdom saving throw. On a failed save, the creature takes 22 ({@damage 4d10}) psychic damage, and it is {@condition frightened} of the dragon for 1 minute. On a successful save, the creature takes half as much damage with no additional effects. A {@condition frightened} creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 11} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonCastingColor: "deep",
    dragonAge: "young",
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR", "U"],
    damageTags: ["I", "P", "S", "Y"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["frightened"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Young Dragon Turtle",
    source: "FTD",
    page: 192,
    size: ["H"],
    type: "dragon",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 19,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 178,
      formula: "17d12 + 68",
    },
    speed: {
      walk: 20,
      swim: 40,
    },
    str: 21,
    dex: 10,
    con: 19,
    int: 10,
    wis: 12,
    cha: 12,
    save: {
      dex: "+4",
      con: "+8",
      wis: "+5",
    },
    senses: ["darkvision 120 ft."],
    passive: 11,
    resist: ["fire"],
    languages: ["Aquan", "Draconic"],
    cr: "10",
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon turtle can breathe air and water."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The dragon turtle makes one Bite attack and two Claw attacks.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 10 ft., one target. {@h}11 ({@damage 1d12 + 5}) piercing damage plus 6 ({@damage 1d12}) lightning damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}9 ({@damage 1d8 + 5}) slashing damage.",
        ],
      },
      {
        name: "Steam Breath {@recharge 5}",
        entries: [
          "The dragon turtle exhales steam in a 30-foot cone. Each creature in that area must make a {@dc 16} Constitution saving throw, taking 42 ({@damage 12d6}) fire damage on a failed save, or half as much damage on a successful one. Being underwater doesn't grant resistance against this damage.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Spells",
            entries: [
              '{@note See the "Variant: Dragons as Innate Spellcasters" inset(s), below.}',
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 9} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "young",
    traitTags: ["Amphibious"],
    senseTags: ["SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["AQ", "DR"],
    damageTags: ["F", "L", "P", "S"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Young Emerald Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 197,
    size: ["L"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["L", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 142,
      formula: "15d10 + 60",
    },
    speed: {
      walk: 40,
      burrow: 30,
      fly: 60,
    },
    str: 21,
    dex: 12,
    con: 19,
    int: 16,
    wis: 14,
    cha: 16,
    save: {
      dex: "+4",
      con: "+7",
      wis: "+5",
      cha: "+6",
    },
    skill: {
      arcana: "+6",
      deception: "+6",
      perception: "+8",
      stealth: "+4",
    },
    senses: ["blindsight 30 ft.", "darkvision 120 ft."],
    passive: 18,
    resist: ["fire", "psychic"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: "8",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 14}):",
        ],
        will: [
          "{@spell mage hand} (the hand is invisible)",
          "{@spell minor illusion}",
        ],
        daily: {
          "1e": [
            "{@spell detect thoughts}",
            "{@spell invisibility}",
            "{@spell silent image}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Tunneler",
        entries: [
          "The dragon can burrow through solid rock at half its burrowing speed and can leave a 10-foot-diameter tunnel in its wake.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 10 ft., one target. {@h}16 ({@damage 2d10 + 5}) piercing damage plus 3 ({@damage 1d6}) psychic damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 8} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d6 + 5}) slashing damage.",
        ],
      },
      {
        name: "Disorienting Breath {@recharge 5}",
        entries: [
          "The dragon exhales a wave of psychic dissonance in a 30-foot cone. Each creature in that area must make a {@dc 15} Intelligence saving throw. On a failed save, the creature takes 31 ({@damage 9d6}) psychic damage, and until the end of its next turn, when the creature makes an attack roll or an ability check, it must roll a {@dice d6} and reduce the total by the number rolled. On a successful save, the creature takes half as much damage with no additional effects.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 14} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "young",
    traitTags: ["Tunneler"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["P", "S", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflictSpell: ["invisible"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Young Moonstone Dragon",
    source: "FTD",
    page: 213,
    size: ["L"],
    type: "dragon",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 18,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 144,
      formula: "17d10 + 51",
    },
    speed: {
      walk: 40,
      fly: 80,
    },
    str: 18,
    dex: 16,
    con: 17,
    int: 18,
    wis: 17,
    cha: 19,
    save: {
      con: "+6",
      int: "+7",
      wis: "+6",
      cha: "+7",
    },
    skill: {
      perception: "+6",
      persuasion: "+7",
      stealth: "+6",
    },
    senses: ["blindsight 30 ft.", "darkvision 120 ft."],
    passive: 16,
    conditionImmune: ["charmed"],
    languages: ["Common", "Draconic", "Sylvan"],
    cr: "8",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no material components and using Charisma as the spellcasting ability (spell save {@dc 15}):",
        ],
        daily: {
          "1e": ["{@spell calm emotions}", "{@spell faerie fire}"],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 10 ft., one target. {@h}15 ({@damage 2d10 + 4}) piercing damage plus 5 ({@damage 1d10}) radiant damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}11 ({@damage 2d6 + 4}) slashing damage.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: [
          "The dragon uses one of the following breath weapons:",
          {
            type: "list",
            style: "list-hang-notitle",
            items: [
              {
                type: "item",
                name: "Dream Breath",
                entries: [
                  "The dragon exhales mist in a 90-foot cone. Each creature in that area must succeed on a {@dc 14} Constitution saving throw or fall {@condition unconscious} for 10 minutes. This effect ends for a creature if the creature takes damage or someone uses an action to wake it.",
                ],
              },
              {
                type: "item",
                name: "Moonlight Breath",
                entries: [
                  "The dragon exhales a beam of moonlight in a 60-foot line that is 5 feet wide. Each creature in that area must make a {@dc 14} Dexterity saving throw, taking 38 ({@damage 7d10}) radiant damage on a failed save, or half as much damage on a successful one.",
                ],
              },
            ],
          },
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 12} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "young",
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR", "S"],
    damageTags: ["P", "R", "S"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["unconscious"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Young Sapphire Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 216,
    size: ["L"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["L", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 157,
      formula: "15d10 + 75",
    },
    speed: {
      walk: 40,
      burrow: 20,
      climb: 40,
      fly: 80,
    },
    str: 21,
    dex: 14,
    con: 20,
    int: 16,
    wis: 15,
    cha: 16,
    save: {
      dex: "+6",
      con: "+9",
      wis: "+6",
      cha: "+7",
    },
    skill: {
      history: "+7",
      perception: "+10",
      persuasion: "+11",
      stealth: "+6",
    },
    senses: ["blindsight 30 ft.", "darkvision 120 ft."],
    passive: 20,
    resist: ["lightning", "thunder"],
    conditionImmune: ["frightened"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: "9",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 15}):",
        ],
        daily: {
          "1e": [
            "{@spell dissonant whispers}",
            "{@spell hold person}",
            "{@spell meld into stone}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Spider Climb",
        entries: [
          "The dragon can climb difficult surfaces, including upside down on ceilings, without needing to make an ability check.",
        ],
      },
      {
        name: "Tunneler",
        entries: [
          "The dragon can burrow through solid rock at half its burrowing speed and can leave a 10-foot-diameter tunnel in its wake.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 10 ft., one target. {@h}16 ({@damage 2d10 + 5}) piercing damage plus 4 ({@damage 1d8}) thunder damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d6 + 5}) slashing damage.",
        ],
      },
      {
        name: "Debilitating Breath {@recharge 5}",
        entries: [
          "The dragon exhales a pulse of high-pitched, nearly inaudible sound in a 30-foot cone. Each creature in that area must make a {@dc 17} Constitution saving throw. On a failed save, the creature takes 33 ({@damage 6d10}) thunder damage and is {@condition incapacitated} until the end of its next turn. On a successful save, the creature takes half as much damage and isn't {@condition incapacitated}.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 11} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Tunneler",
                    entries: [
                      "The dragon can burrow through solid rock at half its burrowing speed and leaves a tunnel in its wake.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "young",
    traitTags: ["Spider Climb", "Tunneler"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["P", "S", "T"],
    damageTagsSpell: ["B", "Y"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["incapacitated"],
    conditionInflictSpell: ["paralyzed", "prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Young Sea Serpent",
    source: "FTD",
    page: 219,
    size: ["H"],
    type: "dragon",
    alignment: ["N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 123,
      formula: "13d12 + 39",
    },
    speed: {
      walk: 10,
      swim: 40,
    },
    str: 19,
    dex: 12,
    con: 17,
    int: 11,
    wis: 13,
    cha: 10,
    save: {
      str: "+7",
      con: "+6",
    },
    skill: {
      perception: "+4",
      stealth: "+4",
    },
    senses: ["darkvision 120 ft."],
    passive: 14,
    immune: ["cold"],
    languages: ["Common", "Draconic"],
    cr: "8",
    trait: [
      {
        name: "Amphibious",
        entries: ["The sea serpent can breathe air and water."],
      },
      {
        name: "Siege Monster",
        entries: [
          "The sea serpent deals double damage to objects and structures.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The sea serpent makes one Bite attack and one Constrict or Tail attack.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 10 ft., one target. {@h}15 ({@damage 2d10 + 4}) piercing damage plus 5 ({@damage 1d10}) cold damage.",
        ],
      },
      {
        name: "Constrict",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 20 ft., one creature. {@h}22 ({@damage 4d8 + 4}) bludgeoning damage. If the target is Large or smaller, it is {@condition grappled} (escape {@dc 15}). Until this grapple ends, the target is {@condition restrained}, and the sea serpent can't constrict another target.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 15 ft., one target. {@h}9 ({@damage 1d10 + 4}) bludgeoning damage. If the target is a creature, it must succeed on a {@dc 15} Strength saving throw or be pushed up to 20 feet away and knocked {@condition prone}.",
        ],
      },
      {
        name: "Rime Breath {@recharge 5}",
        entries: [
          "The sea serpent exhales a 30-foot cone of cold. Each creature in that area must make a {@dc 14} Constitution saving throw, taking 38 ({@damage 7d10}) cold damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    dragonAge: "young",
    traitTags: ["Amphibious", "Siege Monster"],
    senseTags: ["SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "C", "P"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["grappled", "prone", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Young Topaz Dragon",
    group: ["Gem Dragon"],
    source: "FTD",
    page: 223,
    size: ["L"],
    type: {
      type: "dragon",
      tags: ["gem"],
    },
    alignment: ["C", "N"],
    alignmentPrefix: "typically ",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 127,
      formula: "17d10 + 34",
    },
    speed: {
      walk: 40,
      fly: 80,
      swim: 40,
    },
    str: 17,
    dex: 12,
    con: 15,
    int: 16,
    wis: 15,
    cha: 16,
    save: {
      dex: "+4",
      con: "+5",
      wis: "+5",
      cha: "+6",
    },
    skill: {
      intimidation: "+9",
      perception: "+8",
      stealth: "+4",
    },
    senses: ["blindsight 30 ft.", "darkvision 120 ft."],
    passive: 18,
    resist: ["cold", "necrotic"],
    languages: ["Common", "Draconic", "telepathy 120 ft."],
    cr: "7",
    spellcasting: [
      {
        name: "Spellcasting (Psionics)",
        headerEntries: [
          "The dragon casts one of the following spells, requiring no spell components and using Intelligence as the spellcasting ability (spell save {@dc 14}):",
        ],
        daily: {
          "1e": ["{@spell bane}", "{@spell create or destroy water}"],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Amphibious",
        entries: ["The dragon can breathe both air and water."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The dragon makes one Bite attack and two Claw attacks."],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 10 ft., one target. {@h}14 ({@damage 2d10 + 3}) piercing damage plus 3 ({@damage 1d6}) necrotic damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}6 ({@damage 1d6 + 3}) slashing damage.",
        ],
      },
      {
        name: "Desiccating Breath {@recharge 5}",
        entries: [
          "The dragon exhales yellowish necrotic energy in a 30-foot cone. Each creature in that area must make a {@dc 13} Constitution saving throw. On a failed save, the creature takes 28 ({@damage 8d6}) necrotic damage and is weakened until the end of its next turn. A weakened creature has disadvantage on Strength-based ability checks and Strength saving throws, and the creature's weapon attacks that rely on Strength deal half damage. On a successful save, the creature takes half as much damage and isn't weakened.",
        ],
      },
    ],
    variant: [
      {
        type: "inset",
        name: "Customizing Dragons",
        source: "FTD",
        page: 33,
        entries: [
          "You can customize any dragon's stat block to reflect the dragon's unique character. Minor changes such as those below are easy to make and have no impact on a dragon's challenge rating.",
          {
            type: "entries",
            name: "Languages",
            entries: [
              "Most dragons prefer to speak Draconic but learn Common for dealing with allies and minions. But given their high Intelligence and long life span, dragons can easily learn additional languages. You can add languages to a dragon's stat block.",
            ],
          },
          {
            type: "entries",
            name: "Skills",
            entries: [
              "Most dragons are proficient in the {@skill Perception} and {@skill Stealth} skills, and many dragons have additional skill proficiencies. As with languages, you can customize a dragon's skill list (even doubling their proficiency bonus with certain skills) to reflect particular interests and activities. You can also give a dragon tool proficiencies, particularly if the dragon spends time in Humanoid form.",
            ],
          },
          {
            type: "entries",
            name: "Other Traits and Actions",
            entries: [
              "You can borrow traits and actions from other monsters to add unique flavor to a dragon. Consider these examples:",
              {
                type: "list",
                style: "list-hang-notitle",
                items: [
                  {
                    type: "item",
                    name: "Change Shape",
                    entries: [
                      "You can decide that a dragon acquires this action at a younger age than usual, particularly if you want to feature a dragon in Humanoid form in your campaign:",
                      "The dragon magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the dragon's choice).",
                      "In a new form, the dragon retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Flyby",
                    entries: [
                      "The dragon is an agile flier, quick to fly out of enemies' reach.",
                      "The dragon doesn't provoke an opportunity attack when it flies out of an enemy's reach.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Mimicry",
                    entries: [
                      "Impersonating characters or their allies could be a fun trick for a crafty dragon.",
                      "The dragon can mimic any sounds it has heard, including voices. A creature that hears the sounds can tell they are imitations with a successful {@dc 11} Wisdom ({@skill Insight}) check.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Rejuvenation",
                    entries: [
                      "You might decide that dragons in your campaign, being an essential part of the Material Plane, are nearly impossible to destroy. A dragon's life essence might be preserved in the egg from which it first emerged, in its hoard, or in a cavernous hall at the center of the world, just as a lich's essence is hidden in a phylactery.",
                      "If it has an essence-preserving object, a destroyed dragon gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the object.",
                    ],
                  },
                  {
                    type: "item",
                    name: "Special Senses",
                    entries: [
                      "Most dragons have {@sense blindsight} and {@sense darkvision}. You might upgrade {@sense blindsight} to {@sense truesight}, or you could give a dragon with a burrowing speed {@sense tremorsense|MM}.",
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    dragonAge: "young",
    traitTags: ["Amphibious"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR", "TP"],
    damageTags: ["N", "P", "S"],
    spellcastingTags: ["P"],
    miscTags: ["AOE", "MW", "RCH"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
];
